webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_auth_Auth__ = __webpack_require__(37);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__packages_auth_Auth__["a" /* default */]);
var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "https://api." + window.location.hostname + "/api",
});
http.defaults.headers.common = {
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].auth.getToken(),
};
/* harmony default export */ __webpack_exports__["a"] = (http);


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (bus);


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

var ThePlayerBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (ThePlayerBus);


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(376),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-633f332a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(378),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-648cecec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(366),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52d89950",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
    var authenticatedUser = {};

    Vue.auth = {
        user: {},
        setToken: function setToken(token, expiration) {
            localStorage.setItem('token', token);
            localStorage.setItem('expiration', expiration);
        },
        getToken: function getToken() {
            var token = localStorage.getItem('token');
            var expiration = localStorage.getItem('expiration');

            if (!token || !expiration) {
                return null;
            }
            if (Date.now() > parseInt(expiration)) {
                this.destroyToken();
                return null;
            }

            return token;
        },
        destroyToken: function destroyToken() {
            localStorage.removeItem('token');
            localStorage.removeItem('expiration');
        },
        isAuthenticated: function isAuthenticated() {
            return !!this.getToken();
        },
        getUserInfo: function getUserInfo() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                    __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].get('user').then(function (_ref) {
                                        var data = _ref.data;

                                        _this.user = data;

                                        resolve(data);
                                    }, function () {
                                        reject();
                                    });
                                }));

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        setAuthenticatedUser: function setAuthenticatedUser(data) {
            authenticatedUser = data;
        },
        getAuthenticatedUser: function getAuthenticatedUser() {
            return authenticatedUser;
        }
    };

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
        $auth: {
            get: function get() {
                return Vue.auth;
            }
        }
    });
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Validate = function (target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function () {
        var _this = this;
        this.$validator.errors.clear();
        this.$nextTick(function () {
            _this.$validator.validateAll().then(function (isValid) {
                if (isValid) {
                    fn.apply(_this);
                }
            });
        });
    };
    return descriptor;
};
/* harmony default export */ __webpack_exports__["a"] = (Validate);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (bus);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(392),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9d9167da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(342),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a70b891",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(385),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-794961f5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
    Vue.snackbar = {
        error: function error(message) {},
        success: function success(message) {},
        close: function close() {}
    };

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
        $snackbar: {
            get: function get() {
                return Vue.snackbar;
            }
        }
    });
});

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pages_Home_PageHome__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pages_Home_PageHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Pages_Home_PageHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pages_SearchResults_PageSearchResults__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pages_SearchResults_PageSearchResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Pages_SearchResults_PageSearchResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_TracksCreate_PageTracksCreate__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_TracksCreate_PageTracksCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Pages_TracksCreate_PageTracksCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pages_PageTrack__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pages_PageTrack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Pages_PageTrack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_PageTrackEdit__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_PageTrackEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Pages_PageTrackEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pages_PageRegister__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pages_PageRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Pages_PageRegister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_PageLogin__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_PageLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Pages_PageLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_PageLogout__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_PageLogout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Pages_PageLogout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_PageNotFound__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Pages_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Test__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Test__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_PageUser__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_PageUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Pages_PageUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_PageUserHome__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_PageUserHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Pages_PageUserHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Pages_PageUserPlaylists__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Pages_PageUserPlaylists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Pages_PageUserPlaylists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pages_PageUserChannels__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pages_PageUserChannels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Pages_PageUserChannels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Pages_PagePlaylistEdit__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Pages_PagePlaylistEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Pages_PagePlaylistEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Pages_PagePlaylist__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Pages_PagePlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Pages_PagePlaylist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Pages_PageLikes__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Pages_PageLikes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Pages_PageLikes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Pages_PageHistory__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Pages_PageHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Pages_PageHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Pages_PageSubscriptions__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Pages_PageSubscriptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Pages_PageSubscriptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Pages_PageBrowse__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Pages_PageBrowse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Pages_PageBrowse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AudioPlayer__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AudioPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_AudioPlayer__);























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: "history",
    scrollBehavior: function (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        else {
            return { x: 0, y: 0 };
        }
    },
    linkActiveClass: "active",
    routes: [
        { path: "/", name: "Home", component: __WEBPACK_IMPORTED_MODULE_2__components_Pages_Home_PageHome___default.a, redirect: "/browse" },
        { path: "/register", name: "Register", component: __WEBPACK_IMPORTED_MODULE_7__components_Pages_PageRegister___default.a, meta: { forAuth: false, } },
        { path: "/login", name: "Login", component: __WEBPACK_IMPORTED_MODULE_8__components_Pages_PageLogin___default.a, meta: { forAuth: false, } },
        { path: "/logout", name: "Logout", component: __WEBPACK_IMPORTED_MODULE_9__components_Pages_PageLogout___default.a },
        { path: "/browse", name: "Browse", component: __WEBPACK_IMPORTED_MODULE_21__components_Pages_PageBrowse___default.a },
        { path: "/subscriptions", name: "Subscriptions", component: __WEBPACK_IMPORTED_MODULE_20__components_Pages_PageSubscriptions___default.a },
        {
            path: "/users/:id", name: "User", component: __WEBPACK_IMPORTED_MODULE_12__components_Pages_PageUser___default.a, props: true,
            children: [
                { path: "home", alias: "", name: "UserHome", component: __WEBPACK_IMPORTED_MODULE_13__components_Pages_PageUserHome___default.a, },
                { path: "playlists", name: "UserPlaylists", component: __WEBPACK_IMPORTED_MODULE_14__components_Pages_PageUserPlaylists___default.a, props: true, },
                { path: "channels", name: "UserChannels", component: __WEBPACK_IMPORTED_MODULE_15__components_Pages_PageUserChannels___default.a, props: true, },
            ],
        },
        { path: "/tracks/add", name: "TracksCreate", component: __WEBPACK_IMPORTED_MODULE_4__components_Pages_TracksCreate_PageTracksCreate___default.a, meta: { forAuth: true, }, },
        { path: "/tracks/:id", name: "Track", props: true, component: __WEBPACK_IMPORTED_MODULE_5__components_Pages_PageTrack___default.a },
        { path: "/tracks/:id/edit", name: "TrackEdit", props: true, component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_PageTrackEdit___default.a, meta: { forAuth: true, }, },
        { path: "/playlists/:id/edit", name: "PlaylistEdit", props: true, component: __WEBPACK_IMPORTED_MODULE_16__components_Pages_PagePlaylistEdit___default.a, meta: { forAuth: true, }, },
        { path: "/playlists/:id", name: "Playlist", props: true, component: __WEBPACK_IMPORTED_MODULE_17__components_Pages_PagePlaylist___default.a, },
        { path: "/likes", name: "Likes", component: __WEBPACK_IMPORTED_MODULE_18__components_Pages_PageLikes___default.a, },
        { path: "/history", name: "History", component: __WEBPACK_IMPORTED_MODULE_19__components_Pages_PageHistory___default.a, },
        { path: "/search/:q", name: "Search", component: __WEBPACK_IMPORTED_MODULE_3__components_Pages_SearchResults_PageSearchResults___default.a, props: true, },
        { path: "*", component: __WEBPACK_IMPORTED_MODULE_10__components_Pages_PageNotFound___default.a },
        { path: "/test", component: __WEBPACK_IMPORTED_MODULE_11__components_Test___default.a },
        { path: "/test-player", component: __WEBPACK_IMPORTED_MODULE_22__components_AudioPlayer___default.a },
    ]
}));


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_player_ts__ = __webpack_require__(276);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var debug = "production" !== "production";
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
        player: __WEBPACK_IMPORTED_MODULE_3__modules_player_ts__["a" /* default */],
    },
    state: {
        drawer: true,
        rightSidebar: false,
    },
    mutations: {
        setDrawer: function (state, val) { return state.drawer = val; },
        setRightSidebar: function (state, val) { return state.rightSidebar = val; },
        toggleRightSidebar: function (state) { return state.rightSidebar = !state.rightSidebar; },
    },
    strict: "production" !== "production"
});
/* harmony default export */ __webpack_exports__["a"] = (store);


/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(390),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8399f25c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(398),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c1cd6576",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(364),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(394),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ab1797ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(3);



var state = {
    isAuthenticated: false,
    user: {},
    notifications: []
};

var getters = {};

var actions = {
    getUserPlaylists: function getUserPlaylists(context) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get("playlists", { params: { user_id: "me", all: true, with: ["audios"] } }).then(function (response) {
                context.commit("SET_USER_PLAYLISTS", response.data);
                resolve(response);
            }).catch(function (response) {
                reject(error);
            });
        });
    },
    getLikes: function getLikes(context) {
        __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get("audios", { params: { liked_by: "me", all: true } }).then(function (response) {
            context.commit("SET_LIKES", response.data);
        }).catch(function (response) {});
    }
};

var mutations = {
    SET_LIKES: function SET_LIKES(state, audios) {
        state.user.likes = audios;
    },
    SET_IS_AUTHENTICATED: function SET_IS_AUTHENTICATED(state, isAuthenticated) {
        state.isAuthenticated = isAuthenticated;
    },
    SET_USER: function SET_USER(state, user) {
        state.user = user;
    },
    SET_USER_PLAYLISTS: function SET_USER_PLAYLISTS(state, playlists) {
        state.user.playlists = playlists;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TheHeader_TheHeader_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TheHeader_TheHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TheHeader_TheHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ThePlayer_ThePlayer_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ThePlayer_ThePlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ThePlayer_ThePlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TheLeftSidebar_TheLeftSidebar_vue__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TheLeftSidebar_TheLeftSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TheLeftSidebar_TheLeftSidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TheRightSidebar_TheRightSidebar_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TheRightSidebar_TheRightSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TheRightSidebar_TheRightSidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__snackbarBus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var App = (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.snackbar = {
            show: false,
            text: "",
        };
        _this.dark = false;
        _this.isAuthenticating = true;
        return _this;
    }
    Object.defineProperty(App.prototype, "fluid", {
        get: function () {
            return ["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name);
        },
        enumerable: true,
        configurable: true
    });
    App.prototype.setDark = function (val) {
        this.dark = val;
    };
    App.prototype.created = function () {
        var _this = this;
        this.dark = "dark" === localStorage.getItem('theme');
        this["$auth"].getUserInfo().then(function () {
            _this["$auth"].user.token = _this["$auth"].getToken();
            _this.$store.commit('SET_USER', _this["$auth"].user);
            _this.$store.commit('SET_IS_AUTHENTICATED', !!_this.$store.state.user.user);
            _this.isAuthenticating = false;
        }).catch(function () {
            _this.isAuthenticating = false;
        });
        __WEBPACK_IMPORTED_MODULE_6__snackbarBus__["a" /* default */].$on("show", function (text) {
            _this.snackbar.show = false;
            _this.$nextTick(function () {
                _this.snackbar.show = true;
                _this.snackbar.text = text;
            });
        });
        __WEBPACK_IMPORTED_MODULE_7__http__["a" /* default */].get("users/me")
            .then(function (response) {
        })
            .catch(function (response) {
        });
        __WEBPACK_IMPORTED_MODULE_6__snackbarBus__["a" /* default */].$on("success", function (text) {
            _this.snackbar.show = true;
            _this.snackbar.text = text;
        });
    };
    App.prototype.onRouteChanged = function () {
        document.title = "App";
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], App.prototype, "onRouteChanged", null);
    App = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                "the-header": __WEBPACK_IMPORTED_MODULE_2__components_TheHeader_TheHeader_vue___default.a,
                "the-left-sidebar": __WEBPACK_IMPORTED_MODULE_4__components_TheLeftSidebar_TheLeftSidebar_vue___default.a,
                "the-right-sidebar": __WEBPACK_IMPORTED_MODULE_5__components_TheRightSidebar_TheRightSidebar_vue___default.a,
                "the-player": __WEBPACK_IMPORTED_MODULE_3__components_ThePlayer_ThePlayer_vue___default.a,
            },
        })
    ], App);
    return App;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (App);


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var BaseButton = (function (_super) {
    __extends(BaseButton, _super);
    function BaseButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseButton.prototype, "isLoggedIn", {
        get: function () {
            return this.$store.state.isAuthenticated;
        },
        enumerable: true,
        configurable: true
    });
    BaseButton.prototype.onClick = function (e) {
        if (this.member && !this.isLoggedIn) {
            return;
        }
        if (this.ajax) {
        }
        this.$emit('click', e);
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false }),
        __metadata("design:type", Boolean)
    ], BaseButton.prototype, "member", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false }),
        __metadata("design:type", Boolean)
    ], BaseButton.prototype, "ajax", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'btn--active' }),
        __metadata("design:type", String)
    ], BaseButton.prototype, "activeClass", void 0);
    BaseButton = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], BaseButton);
    return BaseButton;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (BaseButton);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var AppGridList = (function (_super) {
    __extends(AppGridList, _super);
    function AppGridList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AppGridList.prototype, "fluid", {
        get: function () {
            return ["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name);
        },
        enumerable: true,
        configurable: true
    });
    AppGridList = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], AppGridList);
    return AppGridList;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (AppGridList);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var AudioImageWithOverlay = (function (_super) {
    __extends(AudioImageWithOverlay, _super);
    function AudioImageWithOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultImageSrc = "https://img.youtube.com/vi/dummy/0.jpg";
        _this.player = _this.$store.state.player;
        return _this;
    }
    Object.defineProperty(AudioImageWithOverlay.prototype, "currentAudioId", {
        get: function () {
            return (this.$store.getters.audio && this.$store.getters.audio.id) || null;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: false }),
        __metadata("design:type", String)
    ], AudioImageWithOverlay.prototype, "height", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Object)
    ], AudioImageWithOverlay.prototype, "audio", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: function () { return ({ play: true, watchLater: false }); } }),
        __metadata("design:type", Object)
    ], AudioImageWithOverlay.prototype, "actions", void 0);
    AudioImageWithOverlay = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], AudioImageWithOverlay);
    return AudioImageWithOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (AudioImageWithOverlay);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var audios = [
    { id: 1, provider: "myouseek", provider_id: "1", previewSource: "https://myouseek.com/audio/1.mp3", },
    { id: 2, provider: "myouseek", provider_id: "2", previewSource: "https://myouseek.com/audio/2.mp3", },
    { id: 3, provider: "myouseek", provider_id: "3", previewSource: "https://myouseek.com/audio/3.mp3", },
    { id: 4, provider: "myouseek", provider_id: "4", previewSource: "https://myouseek.com/audio/4.mp3", },
    { id: 5, provider: "myouseek", provider_id: "5", previewSource: "https://myouseek.com/audio/5.mp3", },
    { id: 6, provider: "myouseek", provider_id: "6", previewSource: "https://myouseek.com/audio/6.mp3", },
];
var playlist = {
    id: 3,
    title: "Test Playlist",
    audios: audios,
};
var AudioPlayer = (function (_super) {
    __extends(AudioPlayer, _super);
    function AudioPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = {
            state: 0,
            time: 0,
            repeat: 0,
            shuffle: false,
            position: null,
            audio: null,
            playlist: [],
            provider: "",
            alteringPlaylist: false,
        };
        _this.buffer = 0;
        _this.bufferValue = 0;
        _this.tooltipTime = "";
        _this.playlist1 = { id: 1, title: "Test Playlist 1", audios: audios.slice(0, 3) };
        _this.playlist2 = { id: 2, title: "Test Playlist 2", audios: audios.slice(3, 6) };
        _this.playlist3 = { id: 2, title: "Test Playlist 3", audios: _this["$deepcopy"](audios) };
        _this.audiosNotInPlaylist = [
            { id: 3, provider: "myouseek", provider_id: "3", previewSource: "https://myouseek.com/audio/3.mp3", },
            { id: 4, provider: "myouseek", provider_id: "4", previewSource: "https://myouseek.com/audio/4.mp3", },
            { id: 5, provider: "myouseek", provider_id: "5", previewSource: "https://myouseek.com/audio/5.mp3", },
        ];
        _this.draggableOptions = {
            disabled: false,
            handle: '.handle',
            ghostClass: 'ghost',
            setData: function (dataTransfer) {
                dataTransfer.setDragImage(document.createElement('div'), 0, 0);
            },
        };
        return _this;
    }
    Object.defineProperty(AudioPlayer.prototype, "audioElement", {
        get: function () {
            return this.$refs["audio"];
        },
        enumerable: true,
        configurable: true
    });
    ;
    AudioPlayer.prototype.onDragStart = function () {
        this.player.alteringPlaylist = true;
    };
    AudioPlayer.prototype.onDragEnd = function (e) {
        var _this = this;
        if (e.oldIndex === this.player.position) {
            this.player.position = e.newIndex;
        }
        else if (e.newIndex <= this.player.position && e.oldIndex > this.player.position) {
            this.player.position++;
        }
        else if (e.newIndex >= this.player.position && e.oldIndex < this.player.position) {
            this.player.position--;
        }
        this.$nextTick(function () {
            _this.player.alteringPlaylist = false;
        });
    };
    AudioPlayer.prototype.remove = function (index) {
        var _this = this;
        this.player.alteringPlaylist = true;
        this.player.playlist.splice(index, 1);
        if (index <= this.player.position) {
            this.player.alteringPlaylist = true;
            this.player.position--;
            this.player.alteringPlaylist = false;
        }
        this.$nextTick(function () {
            _this.player.alteringPlaylist = false;
        });
    };
    Object.defineProperty(AudioPlayer.prototype, "isPlaylingLast", {
        get: function () {
            if (!this.player.playlist) {
                return false;
            }
            return this.player.position === this.player.playlist.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "canNext", {
        get: function () {
            return this.player.repeat === 2 || !this.isPlaylingLast;
        },
        enumerable: true,
        configurable: true
    });
    AudioPlayer.prototype.playNext = function () {
        if (this.player.repeat === 2 && this.isPlaylingLast) {
            this.player.position = 0;
        }
        else {
            this.player.position++;
        }
    };
    AudioPlayer.prototype.playPrevious = function () {
        if (this.player.position === 0) {
            this.player.time = 0;
            this.audioElement.currentTime = 0;
        }
        else {
            this.player.position--;
        }
    };
    AudioPlayer.prototype.toggleRepeat = function () {
        if (this.player.repeat === 2) {
            this.player.repeat = 0;
        }
        else {
            this.player.repeat++;
        }
    };
    AudioPlayer.prototype.onStateChange = function (newVal, oldVal) {
        var _this = this;
        var player = this.player;
        if (newVal === 0) {
            if (player.repeat === 1) {
                player.time = 0;
                player.state = 1;
            }
            else if ((__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(player.playlist).id === player.audio.id) && (player.repeat === 2)) {
                player.audio = player.playlist[0];
                player.time = 0;
                player.state = 1;
            }
        }
        else if (newVal === 1) {
            if (oldVal === 0) {
                this.audioElement.currentTime = 0;
            }
            setTimeout(function () {
                _this.audioElement.play();
            });
        }
        else if (newVal === 2) {
            this.audioElement.pause();
        }
    };
    AudioPlayer.prototype.onShuffleChanged = function (newVal) {
        if (newVal) {
            var part1 = this.player.playlist.slice(0, this.player.position + 1);
            var part2 = this.player.playlist.slice(this.player.position + 1);
            var shuffled = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.shuffle(part2);
            this.player.playlist = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.concat(part1, shuffled);
        }
    };
    AudioPlayer.prototype.onTimeChange = function (newTime, oldTime) {
        this.buffer = (newTime / this.audioElement.duration) * 100;
        this.bufferValue = this.calculateBuffered(this.audioElement);
        if (this.player.state === 0) {
            this.player.state = 1;
        }
        else if (newTime === this.player.audio.duration) {
            this.player.state = 0;
        }
    };
    AudioPlayer.prototype.onPositionChange = function (newPosition, oldPosition) {
        var _this = this;
        if (this.player.alteringPlaylist) {
            return;
        }
        this.player.state = 0;
        this.player.time = 0;
        this.player.audio = this.player.playlist[newPosition];
        this.$nextTick(function () {
            _this.player.state = 1;
        });
    };
    AudioPlayer.prototype.onAudioChange = function (newAudio, oldAudio) {
        var _this = this;
        this.player.time = 0;
        if (this.audioElement) {
            this.audioElement.load();
        }
        if (this.player.state === 1) {
            setTimeout(function () {
                _this.audioElement.play();
            });
        }
    };
    Object.defineProperty(AudioPlayer.prototype, "src", {
        get: function () {
            return this.player.audio.previewSource;
        },
        enumerable: true,
        configurable: true
    });
    AudioPlayer.prototype.calculateBuffered = function (audioElement) {
        if (audioElement === void 0) { audioElement = null; }
        if (!audioElement) {
            audioElement = this.audioElement;
        }
        var buffered = 0;
        if (audioElement.buffered.length) {
            var x = 0;
            while (x < audioElement.buffered.length && audioElement.buffered.start(x) < audioElement.currentTime) {
                ++x;
            }
            if (x < 1)
                x = 1;
            buffered = (audioElement.buffered.end(x - 1) / audioElement.duration) * 100;
        }
        return buffered;
    };
    AudioPlayer.prototype.mounted = function () {
        var _this = this;
        this.audioElement.addEventListener("seeked", function (e) {
            _this.player.time = e.target.currentTime;
        });
        this.audioElement.addEventListener("timeupdate", function (e) {
            _this.player.time = _this.audioElement.currentTime;
        });
        this.audioElement.addEventListener("progress", function (e) {
            _this.bufferValue = _this.calculateBuffered(e.target);
        });
        this.audioElement.addEventListener("ended", function (e) {
            _this.player.state = 0;
            _this.$nextTick(function () {
                if (_this.player.repeat === 1) {
                    _this.player.time = 0;
                    _this.player.state = 1;
                }
                else {
                    if (_this.player.position < _this.player.playlist.length - 1) {
                        _this.player.position++;
                    }
                    else {
                        if (_this.player.repeat === 2) {
                            _this.player.position = 0;
                        }
                    }
                }
            });
        });
    };
    AudioPlayer.prototype.playAudio = function (audio, playlist, position) {
        if (playlist === void 0) { playlist = null; }
        if (position === void 0) { position = 0; }
        if (playlist) {
            this.player.playlist = playlist.audios;
            this.player.position = position;
        }
        else {
            if (!this.player.audio || this.player.audio.id !== audio.id) {
                this.player.playlist.push(audio);
            }
            this.player.position = this.player.playlist.length - 1;
        }
        this.player.audio = audio;
    };
    AudioPlayer.prototype.playPlaylistRandomized = function (playlist) {
        this.player.position = 0;
        this.player.time = 0;
        this.player.playlist = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.shuffle(playlist.audios);
        this.player.audio = this.player.playlist[0];
    };
    AudioPlayer.prototype.playPlaylist = function () {
        this.player.playlist = playlist.audios;
    };
    AudioPlayer.prototype.onClick = function (e) {
        var target = e.target.parentElement.parentElement;
        var totalWidth = target.offsetWidth;
        var clickedWidth = e.offsetX;
        var percentageClicked = (clickedWidth / totalWidth);
        this.audioElement.currentTime = percentageClicked * this.audioElement.duration;
    };
    AudioPlayer.prototype.formatTime = function (time) {
        time = Math.round(time);
        var minutes = Math.floor(time / 60), seconds = time - minutes * 60, sSeconds = seconds < 10 ? "0" + seconds : seconds;
        return minutes + ":" + sSeconds;
    };
    AudioPlayer.prototype.showTime = function (e) {
        if (!this.player.audio) {
            return;
        }
        var target = e.target.parentElement.parentElement, totalWidth = target.offsetWidth, clickedWidth = e.offsetX, percentageHovered = (clickedWidth / totalWidth) * 100;
        this.tooltipTime = this.formatTime((percentageHovered / 100) * this.player.time);
        this.$refs.time["style"].display = "block";
        var tooltipWidth = 60;
        if (e.offsetX > tooltipWidth / 2 && e.offsetX < totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = e.offsetX - tooltipWidth / 2 + "px";
        }
        else if (e.offsetX <= tooltipWidth / 2) {
            this.$refs.time["style"].left = 0;
        }
        else if (e.offsetX > totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = totalWidth - tooltipWidth + "px";
        }
    };
    AudioPlayer.prototype.hideTime = function (e) {
        this.$refs.time["style"].display = "none";
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onStateChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.shuffle"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onShuffleChanged", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.time"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onTimeChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.position"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onPositionChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.audio.id"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onAudioChange", null);
    AudioPlayer = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
            },
        })
    ], AudioPlayer);
    return AudioPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (AudioPlayer);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MenuAddToPlaylist__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MenuAddToPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MenuAddToPlaylist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AudioImageWithOverlay__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AudioImageWithOverlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AudioImageWithOverlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__snackbarBus__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var AudioTeaser = (function (_super) {
    __extends(AudioTeaser, _super);
    function AudioTeaser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuMore = false;
        _this.menuAtp = false;
        _this.defaultImageSrc = "https://img.youtube.com/vi/dummy/0.jpg";
        _this.player = _this.$store.state.player;
        return _this;
    }
    Object.defineProperty(AudioTeaser.prototype, "imgHeight", {
        get: function () {
            return '118px';
        },
        enumerable: true,
        configurable: true
    });
    AudioTeaser.prototype.atp = function () {
        this.menuMore = false;
        this.menuAtp = true;
    };
    AudioTeaser.prototype.addToNextUp = function () {
        this.$store.dispatch("playlistPush", this.audio);
        __WEBPACK_IMPORTED_MODULE_4__snackbarBus__["a" /* default */].$emit("show", "Added to Next up");
    };
    AudioTeaser.prototype.play = function () {
        this.$store.dispatch("playAudio", this.audio);
    };
    AudioTeaser.prototype.pause = function () {
        this.$store.dispatch("pause");
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: false }),
        __metadata("design:type", String)
    ], AudioTeaser.prototype, "height", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Object)
    ], AudioTeaser.prototype, "audio", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: function () { return ({ play: true, watchLater: false }); } }),
        __metadata("design:type", Object)
    ], AudioTeaser.prototype, "actions", void 0);
    AudioTeaser = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                "audio-img": __WEBPACK_IMPORTED_MODULE_3__components_AudioImageWithOverlay___default.a,
                MenuAddToPlaylist: __WEBPACK_IMPORTED_MODULE_2__components_MenuAddToPlaylist___default.a,
            }
        })
    ], AudioTeaser);
    return AudioTeaser;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (AudioTeaser);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarBus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__likesBus__ = __webpack_require__(60);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var AudioButtonLike = (function (_super) {
    __extends(AudioButtonLike, _super);
    function AudioButtonLike() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.liked = false;
        return _this;
    }
    AudioButtonLike.prototype.like = function () {
        var _this = this;
        var params = {
            audio_id: this.audio.id,
        };
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post("/likes", params)
            .then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "Added to Likes");
            _this.liked = true;
            __WEBPACK_IMPORTED_MODULE_4__likesBus__["a" /* default */].$emit("toggled", _this.audio, _this.liked);
        })
            .catch(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "There was an error. Try again");
        });
    };
    AudioButtonLike.prototype.unlike = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].delete("/likes", { params: { audio_id: this.audio.id } })
            .then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "Removed from Likes");
            _this.liked = false;
            __WEBPACK_IMPORTED_MODULE_4__likesBus__["a" /* default */].$emit("toggled", _this.audio, _this.liked);
        }).catch(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "There was an error. Try again");
        });
    };
    AudioButtonLike.prototype.toggleLiked = function () {
        this.liked ? this.unlike() : this.like();
    };
    AudioButtonLike.prototype.onLikesChanged = function (likes) {
        var _this = this;
        if (likes) {
            this.liked = likes.find(function (e) { return e.id === _this.audio.id; });
        }
    };
    AudioButtonLike.prototype.created = function () {
        var _this = this;
        this.liked = this.audio.liked;
        __WEBPACK_IMPORTED_MODULE_4__likesBus__["a" /* default */].$on("toggled", function (audio, val) {
            if (audio.id === _this.audio.id) {
                _this.liked = val;
            }
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Object)
    ], AudioButtonLike.prototype, "audio", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$store.state.user.user.likes", { deep: true, immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AudioButtonLike.prototype, "onLikesChanged", null);
    AudioButtonLike = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], AudioButtonLike);
    return AudioButtonLike;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (AudioButtonLike);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Inputs_InputAudioTags__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Inputs_InputAudioTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Inputs_InputAudioTags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__snackbarBus__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var DialogAddTag = (function (_super) {
    __extends(DialogAddTag, _super);
    function DialogAddTag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            tags: [],
        };
        _this.userDistinctTags = [];
        _this.userAudioTags = [];
        _this.audioTags = [];
        return _this;
    }
    DialogAddTag.prototype.addTag = function (tag) {
        if (this.form.tags.includes(tag))
            return;
        this.form.tags.push(tag);
    };
    DialogAddTag.prototype.created = function () {
        this.getUserDistinctTags();
        this.getUserAudioTags();
        this.getAudioTags();
    };
    DialogAddTag.prototype.submit = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].put("audios/" + this.audio.id + "/tags", { tags: this.form.tags })
            .then(function (response) {
            _this.$emit('input', false);
            __WEBPACK_IMPORTED_MODULE_4__snackbarBus__["a" /* default */].$emit("show", "Tags edited");
        })
            .catch(function (response) {
        });
    };
    DialogAddTag.prototype.getUserDistinctTags = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get("tags", { params: { all: true, distinct: "true", createdBy: "me" } })
            .then(function (response) {
            _this.userDistinctTags = response.data;
        })
            .catch(function (response) {
        });
    };
    DialogAddTag.prototype.getUserAudioTags = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get("tags", { params: { all: true, createdBy: "me", audioId: this.audio.id } })
            .then(function (response) {
            _this.userAudioTags = response.data;
            _this.form.tags = _this.userAudioTags;
        })
            .catch(function (response) {
        });
    };
    DialogAddTag.prototype.getAudioTags = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get("tags", {
            params: {
                all: true,
                audioId: this.audio.id,
                group_by: "tag_id",
                others_only: true,
            }
        })
            .then(function (response) {
            _this.audioTags = response.data;
        })
            .catch(function (response) {
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Object)
    ], DialogAddTag.prototype, "audio", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Boolean)
    ], DialogAddTag.prototype, "value", void 0);
    DialogAddTag = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                InputAudioTags: __WEBPACK_IMPORTED_MODULE_2__components_Inputs_InputAudioTags___default.a,
            },
        })
    ], DialogAddTag);
    return DialogAddTag;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DialogAddTag);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLogin__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FormLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormRegister__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FormRegister__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var DialogAuth = (function (_super) {
    __extends(DialogAuth, _super);
    function DialogAuth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tab = "tab-login";
        return _this;
    }
    DialogAuth = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                FormLogin: __WEBPACK_IMPORTED_MODULE_2__components_FormLogin___default.a,
                FormRegister: __WEBPACK_IMPORTED_MODULE_3__components_FormRegister___default.a,
            }
        })
    ], DialogAuth);
    return DialogAuth;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DialogAuth);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var FormLogin = (function (_super) {
    __extends(FormLogin, _super);
    function FormLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.username = "";
        _this.password = "";
        _this.isLoading = false;
        return _this;
    }
    FormLogin.prototype.getToken = function () {
        var _this = this;
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('token').then(function (response) {
            _this.login(response);
            _this.isLoading = false;
        }, function (response) {
            _this.isLoading = false;
        });
    };
    FormLogin.prototype.login = function (response) {
        var _this = this;
        var data = {
            client_id: 2,
            client_secret: response.data,
            grant_type: 'password',
            username: this.username,
            password: this.password,
        };
        var axiosConfigUrl = "http://" + window.location.hostname + ":4562/" + "oauth/token";
        if (window.location.hostname === 'myouseek.com') {
            axiosConfigUrl = 'https://api.' + window.location.hostname + "/oauth/token";
        }
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post(axiosConfigUrl, data).then(function (response) {
            _this["$auth"].setToken(response.data.access_token, response.data.expires_in + Date.now() + 15 * 24 * 60 * 60 * 1000);
            _this.$router.push("/");
        }, function (response) {
            _this.isLoading = false;
        });
    };
    FormLogin = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], FormLogin);
    return FormLogin;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (FormLogin);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var PageRegister = (function (_super) {
    __extends(PageRegister, _super);
    function PageRegister() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageRegister.prototype.register = function () {
        var _this = this;
        var params = {
            email: this.email,
            name: this.username,
            password: this.password,
        };
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("users", params).then(function (response) {
            _this.$router.push("/login");
        }, function (response) {
            console.error(response);
        });
    };
    PageRegister = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Component"]
    ], PageRegister);
    return PageRegister;
}(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageRegister);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var InputAudioTags = (function (_super) {
    __extends(InputAudioTags, _super);
    function InputAudioTags() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tags = [];
        return _this;
    }
    InputAudioTags.prototype.getTags = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get("tags", { params: { all: true, distinct: true, has: "tracks" } })
            .then(function (response) {
            _this.tags = response.data;
        })
            .catch(function (response) {
        });
    };
    InputAudioTags.prototype.created = function () {
        this.getTags();
    };
    InputAudioTags.prototype.updateOnSpace = function (tags) {
        this.$refs[tags]["onEnterDown"]();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Inject"])("$validator"),
        __metadata("design:type", Object)
    ], InputAudioTags.prototype, "$validator", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Array)
    ], InputAudioTags.prototype, "value", void 0);
    InputAudioTags = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], InputAudioTags);
    return InputAudioTags;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (InputAudioTags);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var InputTrackArtist = (function (_super) {
    __extends(InputTrackArtist, _super);
    function InputTrackArtist() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Inject"])("$validator"),
        __metadata("design:type", Object)
    ], InputTrackArtist.prototype, "$validator", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", String)
    ], InputTrackArtist.prototype, "value", void 0);
    InputTrackArtist = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], InputTrackArtist);
    return InputTrackArtist;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (InputTrackArtist);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var InputTrackLyricsSource = (function (_super) {
    __extends(InputTrackLyricsSource, _super);
    function InputTrackLyricsSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Inject"])("$validator"),
        __metadata("design:type", Object)
    ], InputTrackLyricsSource.prototype, "$validator", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", String)
    ], InputTrackLyricsSource.prototype, "value", void 0);
    InputTrackLyricsSource = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], InputTrackLyricsSource);
    return InputTrackLyricsSource;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (InputTrackLyricsSource);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var InputSource = (function (_super) {
    __extends(InputSource, _super);
    function InputSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputSource.prototype.customURL = function (value) {
        return !!value.match(/youtube.*\b[\w\-]{11}\b|myouseek/) || 'Make sure you use youtube video link';
    };
    ;
    InputSource.prototype.validate = function () {
        var _this = this;
        setTimeout(function () {
            _this.$validator.validate("source");
        }, 0);
    };
    InputSource.prototype.onValueChanged = function (val) {
        var _this = this;
        var matches = val.match(/youtube.*\b([\w\-]{11}\b)/);
        if (matches) {
            var youtubeApiKey = "AIzaSyCO7KyCr8JB_UEDQPfq197nogWL_PgRdqs";
            var url = "https://www.googleapis.com/youtube/v3/videos?id=" + matches[1] + "&key=" + youtubeApiKey + "&fields=items(snippet(title))&part=snippet";
            var request_1 = new XMLHttpRequest();
            request_1.onreadystatechange = function () {
                if (request_1.readyState === 4) {
                    if (request_1.status === 200) {
                        _this.$emit("linked", JSON.parse(request_1.response)["items"][0].snippet.title);
                    }
                }
            };
            request_1.open("GET", url, true);
            request_1.send(null);
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Inject"])("$validator"),
        __metadata("design:type", Object)
    ], InputSource.prototype, "$validator", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", String)
    ], InputSource.prototype, "value", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("value", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], InputSource.prototype, "onValueChanged", null);
    InputSource = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], InputSource);
    return InputSource;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (InputSource);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var InputTrackTitle = (function (_super) {
    __extends(InputTrackTitle, _super);
    function InputTrackTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Inject"])("$validator"),
        __metadata("design:type", Object)
    ], InputTrackTitle.prototype, "$validator", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", String)
    ], InputTrackTitle.prototype, "value", void 0);
    InputTrackTitle = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], InputTrackTitle);
    return InputTrackTitle;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (InputTrackTitle);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var LayoutPage = (function (_super) {
    __extends(LayoutPage, _super);
    function LayoutPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], LayoutPage);
    return LayoutPage;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LayoutPage);


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuAddToPlaylistItem__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuAddToPlaylistItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MenuAddToPlaylistItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__snackbarBus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators_validate__ = __webpack_require__(59);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var MenuAddToPlaylist = (function (_super) {
    __extends(MenuAddToPlaylist, _super);
    function MenuAddToPlaylist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.creatingPlaylist = false;
        _this.playlists = [];
        _this.form = {
            title: '',
            visibility: 'private',
        };
        return _this;
    }
    MenuAddToPlaylist.prototype.onPlaylistsChanged = function () {
        this.playlists = this.$store.state.user.user.playlists;
    };
    MenuAddToPlaylist.prototype.onMenuToggle = function (val) {
        var _this = this;
        if (val) {
            this.playlists = [];
            this.$store.dispatch("getUserPlaylists").then(function (r) {
                _this.$nextTick(function () {
                    _this.playlists = _this.$store.state.user.user.playlists;
                });
            });
        }
    };
    MenuAddToPlaylist.prototype.submit = function () {
        var _this = this;
        var params = this["$deepcopy"](this.form);
        params.audioId = this.audio.id;
        this.$refs.btnSubmit["$el"].disabled = "disabled";
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post("/playlists", params)
            .then(function (response) {
            _this.$refs.btnSubmit["$el"].disabled = null;
            __WEBPACK_IMPORTED_MODULE_4__snackbarBus__["a" /* default */].$emit("show", "Added to new playlist");
            _this.form = {
                title: "",
                visibility: "private",
            };
            _this.creatingPlaylist = false;
            _this.$store.dispatch("getUserPlaylists");
        })
            .catch(function (error) {
            _this.$refs.btnSubmit["$el"].disabled = null;
            __WEBPACK_IMPORTED_MODULE_4__snackbarBus__["a" /* default */].$emit("show", "There was an error. Try again");
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Object)
    ], MenuAddToPlaylist.prototype, "audio", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Boolean)
    ], MenuAddToPlaylist.prototype, "value", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", String)
    ], MenuAddToPlaylist.prototype, "activator", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$store.state.user.user.playlists", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MenuAddToPlaylist.prototype, "onPlaylistsChanged", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("value"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], MenuAddToPlaylist.prototype, "onMenuToggle", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5__decorators_validate__["a" /* default */],
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MenuAddToPlaylist.prototype, "submit", null);
    MenuAddToPlaylist = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                'playlist': __WEBPACK_IMPORTED_MODULE_3__MenuAddToPlaylistItem___default.a,
            },
        })
    ], MenuAddToPlaylist);
    return MenuAddToPlaylist;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MenuAddToPlaylist);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snackbarBus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AudioMenuAddToPlaylistItem = (function (_super) {
    __extends(AudioMenuAddToPlaylistItem, _super);
    function AudioMenuAddToPlaylistItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isInPlaylist = false;
        return _this;
    }
    AudioMenuAddToPlaylistItem.prototype.addToPlaylist = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post("playlists/" + this.playlist.id + "/audios", { id: this.audioId })
            .then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "Added to playlist");
            _this.isInPlaylist = true;
        })
            .catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "There was an error. Try again");
        });
    };
    AudioMenuAddToPlaylistItem.prototype.removeFromPlaylist = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].delete("playlists/" + this.playlist.id + "/audios", { params: { audio_id: this.audioId } })
            .then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "Removed from playlist");
            _this.isInPlaylist = false;
        })
            .catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "There was an error. Try again");
        });
    };
    AudioMenuAddToPlaylistItem.prototype.toggle = function () {
        if (this.isInPlaylist) {
            this.removeFromPlaylist();
        }
        else {
            this.addToPlaylist();
        }
    };
    AudioMenuAddToPlaylistItem.prototype.created = function () {
        var _this = this;
        if (this.playlist.audios.filter(function (t) { return t.id === _this.audioId; }).length) {
            this.isInPlaylist = true;
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Object)
    ], AudioMenuAddToPlaylistItem.prototype, "playlist", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Number)
    ], AudioMenuAddToPlaylistItem.prototype, "audioId", void 0);
    AudioMenuAddToPlaylistItem = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], AudioMenuAddToPlaylistItem);
    return AudioMenuAddToPlaylistItem;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (AudioMenuAddToPlaylistItem);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PageTitle = (function (_super) {
    __extends(PageTitle, _super);
    function PageTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageTitle = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageTitle);
    return PageTitle;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageTitle);


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AudioTeaser__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AudioTeaser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AudioTeaser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filters__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var PageHome = (function (_super) {
    __extends(PageHome, _super);
    function PageHome() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.audios = [];
        _this.latestAudios = [];
        return _this;
    }
    PageHome.prototype.getTracks = function () {
        var _this = this;
        var data = {
            params: {
                page: 1,
                per_page: 12,
            }
        };
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/audios', data).then(function (response) {
            _this.audios = response.data.data;
        }, function (response) {
        });
    };
    PageHome.prototype.getLatestTracks = function () {
        var _this = this;
        var data = {
            params: {
                page: 1,
                per_page: 12,
                order_by: "created_at",
                order: "DESC",
            }
        };
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/audios', data).then(function (response) {
            _this.latestAudios = response.data.data;
        }, function (response) {
        });
    };
    PageHome.prototype.created = function () {
        this.getTracks();
        this.getLatestTracks();
    };
    PageHome = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                'filters': __WEBPACK_IMPORTED_MODULE_4__filters___default.a,
                "audio-teaser": __WEBPACK_IMPORTED_MODULE_3__components_AudioTeaser___default.a,
            },
        })
    ], PageHome);
    return PageHome;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageHome);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Filters = (function (_super) {
    __extends(Filters, _super);
    function Filters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filters = {
            tags: "",
            time: "",
            sort: "",
        };
        _this.tags = [
            'tag 1',
            'tag 2',
            'tag 3',
        ];
        _this.times = [
            'Any Time',
            'Today',
            'This week',
            'This month',
        ];
        _this.sorts = [
            'Relevance',
            'Likes',
            'Promoted',
        ];
        return _this;
    }
    Filters = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Filters);
    return Filters;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Filters);


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AudioTeaser__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AudioTeaser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AudioTeaser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pages_PageBrowseTracksFilters__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pages_PageBrowseTracksFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Pages_PageBrowseTracksFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var PageBrowse = (function (_super) {
    __extends(PageBrowse, _super);
    function PageBrowse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTab = "";
        _this.tabs = [
            { id: "tab-tracks", text: "Tracks" },
            { id: "tab-channels", text: "Channels" },
        ];
        _this.filters = {
            tagIds: [],
            sort: "-created_at",
            time: "",
        };
        _this.page = 1;
        _this.last_page = 0;
        _this.tracks = [];
        return _this;
    }
    PageBrowse.prototype.updateFilters = function (val) {
        this.filters = val;
    };
    PageBrowse.prototype.getTracks = function () {
        var _this = this;
        var params = {
            page: this.page,
            per_page: 12,
            tags: this.filters.tagIds,
            sort: this.filters.sort,
            time: this.filters.time,
            type: "track",
        };
        __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].get("/audios", { params: params }).then(function (response) {
            _this.tracks = response.data.data;
            _this.last_page = response.data.last_page;
        }, function (response) {
        });
    };
    PageBrowse.prototype.onFiltersChanged = function () {
        this.getTracks();
        this.page = 1;
    };
    PageBrowse.prototype.onPageChange = function () {
        this.getTracks();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("filters", { deep: true, immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageBrowse.prototype, "onFiltersChanged", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("page"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageBrowse.prototype, "onPageChange", null);
    PageBrowse = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                AudioTeaser: __WEBPACK_IMPORTED_MODULE_2__components_AudioTeaser___default.a,
                TracksFilters: __WEBPACK_IMPORTED_MODULE_3__components_Pages_PageBrowseTracksFilters___default.a,
            }
        })
    ], PageBrowse);
    return PageBrowse;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageBrowse);


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var Filters = (function (_super) {
    __extends(Filters, _super);
    function Filters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            tagIds: [],
            time: "",
            sort: "-created_at",
        };
        _this.tags = [];
        _this.times = [
            { value: "", text: 'Any Time' },
            { value: "1", text: 'Today' },
            { value: "7", text: 'This week' },
            { value: "30", text: 'This month' },
        ];
        _this.sorts = [
            { value: "-created_at", text: 'Time added' },
            { value: "likes", text: 'Likes' },
        ];
        return _this;
    }
    Filters.prototype.getTags = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get("tags", { params: { all: true } })
            .then(function (response) {
            _this.tags = response.data;
        })
            .catch(function (response) {
        });
    };
    Filters.prototype.onInputChange = function () {
        this.$emit("input", this.form);
    };
    Filters.prototype.created = function () {
        this.getTags();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("form", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Filters.prototype, "onInputChange", null);
    Filters = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Filters);
    return Filters;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Filters);


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var PageHistory = (function (_super) {
    __extends(PageHistory, _super);
    function PageHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultImageSrc = "https://img.youtube.com/vi/dummy/0.jpg";
        _this.audios = [];
        _this.sort = "position";
        _this.sortItems = [
            { value: "position", text: "Default" },
            { value: "-position", text: "Reverse" },
            { value: "created_at", text: "Date added (newest)" },
            { value: "-created_at", text: "Date added (oldest)" },
        ];
        _this.loading = true;
        return _this;
    }
    Object.defineProperty(PageHistory.prototype, "imgSrc", {
        get: function () {
            if (this.audios.length) {
                return this.audios[0].imgSource;
            }
            return this.defaultImageSrc;
        },
        enumerable: true,
        configurable: true
    });
    PageHistory.prototype.getHistory = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get("/views", { params: { all: true } })
            .then(function (response) {
            _this.audios = response.data;
            _this.loading = false;
        })
            .catch(function (response) {
        });
    };
    PageHistory.prototype.play = function (shuffled) {
        var _this = this;
        this.$store.dispatch("setPlaylist", []);
        this.$nextTick(function () {
            _this.$store.dispatch("setPlaylist", shuffled ? __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.shuffle(_this.audios) : _this.audios);
            _this.$store.dispatch("setPosition", 0);
            _this.$nextTick(function () {
                _this.$store.dispatch("setState", 1);
            });
        });
    };
    PageHistory.prototype.onRouteChange = function () {
        this.getHistory();
    };
    PageHistory.prototype.onSortChange = function () {
        this.getHistory();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageHistory.prototype, "onRouteChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("sort"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageHistory.prototype, "onSortChange", null);
    PageHistory = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
                "playlist-audio": __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio___default.a,
            },
        })
    ], PageHistory);
    return PageHistory;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageHistory);


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var PageLikes = (function (_super) {
    __extends(PageLikes, _super);
    function PageLikes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultImageSrc = "https://img.youtube.com/vi/dummy/0.jpg";
        _this.audios = [];
        _this.sort = "position";
        _this.sortItems = [
            { value: "position", text: "Default" },
            { value: "-position", text: "Reverse" },
            { value: "created_at", text: "Date added (newest)" },
            { value: "-created_at", text: "Date added (oldest)" },
        ];
        _this.loading = true;
        return _this;
    }
    Object.defineProperty(PageLikes.prototype, "imgSrc", {
        get: function () {
            if (this.audios.length) {
                return this.audios[0].imgSource;
            }
            return this.defaultImageSrc;
        },
        enumerable: true,
        configurable: true
    });
    PageLikes.prototype.getLikes = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get("/likes", { params: { all: true } })
            .then(function (response) {
            _this.audios = response.data;
            _this.loading = false;
        })
            .catch(function (response) {
        });
    };
    PageLikes.prototype.play = function (shuffled) {
        var _this = this;
        this.$store.dispatch("setPlaylist", []);
        this.$nextTick(function () {
            _this.$store.dispatch("setPlaylist", shuffled ? __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.shuffle(_this.audios) : _this.audios);
            _this.$store.dispatch("setPosition", 0);
            _this.$nextTick(function () {
                _this.$store.dispatch("setState", 1);
            });
        });
    };
    PageLikes.prototype.onRouteChange = function () {
        this.getLikes();
    };
    PageLikes.prototype.onSortChange = function () {
        this.getLikes();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageLikes.prototype, "onRouteChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("sort"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageLikes.prototype, "onSortChange", null);
    PageLikes = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
                "playlist-audio": __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio___default.a,
            },
        })
    ], PageLikes);
    return PageLikes;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageLikes);


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var PageLogin = (function (_super) {
    __extends(PageLogin, _super);
    function PageLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.username = "";
        _this.password = "";
        _this.isLoading = false;
        return _this;
    }
    PageLogin.prototype.getToken = function () {
        var _this = this;
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('token').then(function (response) {
            _this.login(response);
            _this.isLoading = false;
        }, function (response) {
            _this.isLoading = false;
        });
    };
    PageLogin.prototype.login = function (response) {
        var _this = this;
        var data = {
            client_id: 2,
            client_secret: response.data,
            grant_type: 'password',
            username: this.username,
            password: this.password,
        };
        var axiosConfigUrl = "http://" + window.location.hostname + ":4562/" + "oauth/token";
        if (window.location.hostname === 'myouseek.com') {
            axiosConfigUrl = 'https://api.' + window.location.hostname + "/oauth/token";
        }
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(axiosConfigUrl, data).then(function (response) {
            _this["$auth"].setToken(response.data.access_token, response.data.expires_in + Date.now() + 15 * 24 * 60 * 60 * 1000);
            _this.$router.push("/");
            location.reload();
        }, function (response) {
            _this.isLoading = false;
        });
    };
    PageLogin = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Component"]
    ], PageLogin);
    return PageLogin;
}(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageLogin);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PageLogout = (function (_super) {
    __extends(PageLogout, _super);
    function PageLogout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageLogout.prototype.logout = function () {
        this["$auth"].destroyToken();
    };
    PageLogout.prototype.created = function () {
        this.logout();
        this.$router.push("/");
        location.reload();
    };
    PageLogout = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageLogout);
    return PageLogout;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageLogout);


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var MyComponent = (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyComponent = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], MyComponent);
    return MyComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MyComponent);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarBus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var PagePlaylist = (function (_super) {
    __extends(PagePlaylist, _super);
    function PagePlaylist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultImageSrc = "https://img.youtube.com/vi/dummy/0.jpg";
        _this.playlist = null;
        _this.draggableOptions = {
            disabled: false,
            handle: '.handle',
            ghostClass: 'ghost',
        };
        _this.sort = "position";
        _this.sortItems = [
            { value: "position", text: "Manual sort" },
            { value: "created_at", text: "Date added (newest)" },
            { value: "-created_at", text: "Date added (oldest)" },
        ];
        return _this;
    }
    Object.defineProperty(PagePlaylist.prototype, "imgSrc", {
        get: function () {
            if (this.playlist.audios.length) {
                return this.playlist.audios[0].imgSource;
            }
            return this.defaultImageSrc;
        },
        enumerable: true,
        configurable: true
    });
    PagePlaylist.prototype.onStart = function (e) {
        this.$refs["list-audios"]["$el"].classList.remove("use-hover");
    };
    PagePlaylist.prototype.onEnd = function (e) {
        this.$refs["list-audios"]["$el"].classList.add("use-hover");
    };
    PagePlaylist.prototype.play = function (shuffled) {
        var _this = this;
        this.$store.dispatch("setPlaylist", []);
        this.$nextTick(function () {
            _this.$store.dispatch("setPlaylist", shuffled ? __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.shuffle(_this.playlist.audios) : _this.playlist.audios);
            _this.$store.dispatch("setPosition", 0);
            _this.$nextTick(function () {
                _this.$store.dispatch("setState", 1);
            });
        });
    };
    PagePlaylist.prototype.onUpdate = function (e) {
        var _this = this;
        this.draggableOptions.disabled = true;
        var params = {
            op: "move",
            oldPosition: e.oldIndex + 1,
            newPosition: e.newIndex + 1
        };
        __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].patch("playlists/" + this.id + "/audios", params)
            .then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "Playlist updated");
            _this.draggableOptions.disabled = false;
        })
            .catch(function (response) {
            _this.draggableOptions.disabled = false;
        });
    };
    PagePlaylist.prototype.onRemoved = function (index) {
        this.playlist.audios.splice(index, 1);
    };
    PagePlaylist.prototype.getPlaylist = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].get("playlists/" + this.id, { params: { with: ["owner"] } }).then(function (response) {
            _this.playlist = response.data;
        }, function (response) {
        });
    };
    PagePlaylist.prototype.getPlaylistAudios = function () {
        var _this = this;
        var params = {
            sort: this.sort,
            all: true,
        };
        __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].get("playlists/" + this.id + "/audios", { params: params }).then(function (response) {
            _this.playlist["audios"] = response.data;
        }, function (response) {
        });
    };
    PagePlaylist.prototype.deletePlaylist = function () {
        var _this = this;
        if (window.confirm("Are you sure you want to delete playlist?")) {
            __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].delete("playlists/" + this.playlist.id)
                .then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("Playlist deleted");
                _this.$store.dispatch("getUserPlaylists");
                _this.$router.push("/users/" + _this.$store.state.user.user.id + "/playlists");
            })
                .catch(function (response) {
            });
        }
    };
    PagePlaylist.prototype.onRouteChange = function () {
        this.playlist = null;
        this.getPlaylist();
    };
    PagePlaylist.prototype.onSortChange = function () {
        this.getPlaylistAudios();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])([String, Number]),
        __metadata("design:type", Object)
    ], PagePlaylist.prototype, "id", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PagePlaylist.prototype, "onRouteChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("sort"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PagePlaylist.prototype, "onSortChange", null);
    PagePlaylist = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a,
                "playlist-audio": __WEBPACK_IMPORTED_MODULE_2__PagePlaylistAudio___default.a,
            },
        })
    ], PagePlaylist);
    return PagePlaylist;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PagePlaylist);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var PagePlaylistAudio = (function (_super) {
    __extends(PagePlaylistAudio, _super);
    function PagePlaylistAudio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PagePlaylistAudio.prototype.remove = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].delete("playlists/" + this.playlist.id + "/audios", { params: { position: this.index + 1 } })
            .then(function (response) {
            _this.$emit("removed", _this.index);
        })
            .catch(function (response) {
        });
    };
    PagePlaylistAudio.prototype.created = function () {
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Object)
    ], PagePlaylistAudio.prototype, "audio", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Number)
    ], PagePlaylistAudio.prototype, "index", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: false }),
        __metadata("design:type", String)
    ], PagePlaylistAudio.prototype, "sort", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: false, default: true }),
        __metadata("design:type", Boolean)
    ], PagePlaylistAudio.prototype, "editable", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Object)
    ], PagePlaylistAudio.prototype, "playlist", void 0);
    PagePlaylistAudio = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                AudioImage: __WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay___default.a,
            }
        })
    ], PagePlaylistAudio);
    return PagePlaylistAudio;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PagePlaylistAudio);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PagePlaylistEdit = (function (_super) {
    __extends(PagePlaylistEdit, _super);
    function PagePlaylistEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.playlist = null;
        return _this;
    }
    PagePlaylistEdit.prototype.getPlaylist = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get("playlists/" + this.id).then(function (response) {
            _this.playlist = response.data;
        }, function (response) {
        });
    };
    PagePlaylistEdit.prototype.onRouteChange = function () {
        this.getPlaylist;
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])([String, Number]),
        __metadata("design:type", Object)
    ], PagePlaylistEdit.prototype, "id", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PagePlaylistEdit.prototype, "onRouteChange", null);
    PagePlaylistEdit = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({})
    ], PagePlaylistEdit);
    return PagePlaylistEdit;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PagePlaylistEdit);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var PageRegister = (function (_super) {
    __extends(PageRegister, _super);
    function PageRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.email = "";
        _this.username = "";
        _this.password = "";
        return _this;
    }
    PageRegister.prototype.register = function () {
        var _this = this;
        var params = {
            email: this.email,
            name: this.username,
            password: this.password,
        };
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("users", params).then(function (response) {
            _this.$router.push("/login");
        }, function (response) {
            console.error(response);
        });
    };
    PageRegister = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Component"]
    ], PageRegister);
    return PageRegister;
}(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageRegister);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PageSubscriptions = (function (_super) {
    __extends(PageSubscriptions, _super);
    function PageSubscriptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageSubscriptions = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageSubscriptions);
    return PageSubscriptions;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageSubscriptions);


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarBus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__likesBus__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ButtonLikeAudio__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ButtonLikeAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ButtonLikeAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MenuAddToPlaylist__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MenuAddToPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MenuAddToPlaylist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DialogAddTag__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DialogAddTag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_DialogAddTag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AudioImageWithOverlay__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AudioImageWithOverlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AudioImageWithOverlay__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var PageTrack = (function (_super) {
    __extends(PageTrack, _super);
    function PageTrack() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTab = "lyrics";
        _this.atpMenu = false;
        _this.dialogAddTag = false;
        _this.track = null;
        _this.state = _this.$store.state;
        _this.playlists = [];
        _this.liked = false;
        return _this;
    }
    Object.defineProperty(PageTrack.prototype, "embedURL", {
        get: function () {
            if (!this.track.lyricsSource) {
                return null;
            }
            return this.track.lyricsSource.replace(/songs/, "embed/songs");
        },
        enumerable: true,
        configurable: true
    });
    PageTrack.prototype.getTrack = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get("audios/" + this.id, { params: { with: ["tags", "user"] } }).then(function (response) {
            _this.track = response.data;
            _this.$nextTick(function () {
                document.title = _this.track.artist + " - " + _this.track.name;
                _this.liked = _this.track.liked;
            });
        }, function (response) {
        });
    };
    PageTrack.prototype.isInUsersPlaylist = function (playlistId) {
        return this.track.user_playlists.map(function (e) {
            return e.id;
        }).includes(playlistId);
    };
    PageTrack.prototype.like = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post("likes", { audioId: this.id })
            .then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "Liked");
            _this.liked = true;
        })
            .catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "There was an error. Try again");
        });
    };
    PageTrack.prototype.unlike = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].delete("likes", { params: { audioId: this.id } })
            .then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "Like removed");
            _this.liked = false;
        })
            .catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_3__snackbarBus__["a" /* default */].$emit("show", "There was an error. Try again");
        });
    };
    PageTrack.prototype.deleteTrack = function () {
        var _this = this;
        var params = {};
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].delete('tracks/' + this.id, params).then(function (response) {
            _this.$router.push("/");
        }, function (response) {
        });
    };
    PageTrack.prototype.getPlaylists = function () {
        var _this = this;
        var params = {};
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('users/me/playlists', params).then(function (response) {
            _this.playlists = response.data;
        }, function (response) {
        });
    };
    PageTrack.prototype.onRouteChanged = function () {
        this.track = null;
        this.getTrack();
    };
    PageTrack.prototype.onStorePlaylistsChange = function (val) {
        this.playlists = val;
    };
    PageTrack.prototype.onPlaylistsChange = function (val) {
        var _this = this;
        if (val && val.length) {
            this.liked = this.state.user.user.liked && this.state.user.user.liked.some(function (audio) { return +audio.id === +_this.id; });
        }
    };
    PageTrack.prototype.onDialogAddTagToggle = function (newVal) {
        if (!newVal) {
            this.getTrack();
        }
    };
    PageTrack.prototype.created = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4__likesBus__["a" /* default */].$on("toggled", function (audio, liked) {
            _this.track.liked = liked;
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])([Number, String]),
        __metadata("design:type", Object)
    ], PageTrack.prototype, "id", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onRouteChanged", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("state.user.user.playlists", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onStorePlaylistsChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("playlists", { immediate: true, deep: true, }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onPlaylistsChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("dialogAddTag"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onDialogAddTagToggle", null);
    PageTrack = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                'like': __WEBPACK_IMPORTED_MODULE_5__components_ButtonLikeAudio___default.a,
                MenuAddToPlaylist: __WEBPACK_IMPORTED_MODULE_6__components_MenuAddToPlaylist___default.a,
                DialogAddTag: __WEBPACK_IMPORTED_MODULE_7__components_DialogAddTag___default.a,
                AudioImage: __WEBPACK_IMPORTED_MODULE_8__components_AudioImageWithOverlay___default.a,
            },
        })
    ], PageTrack);
    return PageTrack;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageTrack);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageTrackEditDialogName__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageTrackEditDialogName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PageTrackEditDialogName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageTrackEditDialogArtist__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageTrackEditDialogArtist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PageTrackEditDialogArtist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageTrackEditDialogSource__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageTrackEditDialogSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PageTrackEditDialogSource__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var PageTrackEdit = (function (_super) {
    __extends(PageTrackEdit, _super);
    function PageTrackEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.track = null;
        _this.dialogName = false;
        _this.dialogArtist = false;
        _this.dialogSource = false;
        return _this;
    }
    PageTrackEdit.prototype.created = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get("tracks/" + this.id)
            .then(function (response) {
            _this.track = response.data;
        })
            .catch(function (response) {
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])([Number, String]),
        __metadata("design:type", Object)
    ], PageTrackEdit.prototype, "id", void 0);
    PageTrackEdit = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                DialogName: __WEBPACK_IMPORTED_MODULE_3__PageTrackEditDialogName___default.a,
                DialogArtist: __WEBPACK_IMPORTED_MODULE_4__PageTrackEditDialogArtist___default.a,
                DialogSource: __WEBPACK_IMPORTED_MODULE_5__PageTrackEditDialogSource___default.a,
            }
        })
    ], PageTrackEdit);
    return PageTrackEdit;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageTrackEdit);


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PageTrackEditDialogArtist = (function (_super) {
    __extends(PageTrackEditDialogArtist, _super);
    function PageTrackEditDialogArtist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.artist = "";
        return _this;
    }
    PageTrackEditDialogArtist.prototype.submit = function () {
        var params = {
            artist: this.artist,
        };
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].patch('tracks/' + this.track.id, params).then(function (response) {
        }, function (response) {
            console.error(response);
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Object)
    ], PageTrackEditDialogArtist.prototype, "track", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Boolean)
    ], PageTrackEditDialogArtist.prototype, "value", void 0);
    PageTrackEditDialogArtist = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageTrackEditDialogArtist);
    return PageTrackEditDialogArtist;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageTrackEditDialogArtist);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PageTrackEditDialogName = (function (_super) {
    __extends(PageTrackEditDialogName, _super);
    function PageTrackEditDialogName() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "";
        return _this;
    }
    PageTrackEditDialogName.prototype.submit = function () {
        var params = {
            name: this.name,
        };
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post("tracks/" + this.track.id, params, {})
            .then(function (response) {
        })
            .catch(function (response) {
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Object)
    ], PageTrackEditDialogName.prototype, "track", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Boolean)
    ], PageTrackEditDialogName.prototype, "value", void 0);
    PageTrackEditDialogName = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageTrackEditDialogName);
    return PageTrackEditDialogName;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageTrackEditDialogName);


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PageTrackEditDialogSource = (function (_super) {
    __extends(PageTrackEditDialogSource, _super);
    function PageTrackEditDialogSource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.source = "";
        return _this;
    }
    PageTrackEditDialogSource.prototype.submit = function () {
        var params = {
            url: this.source,
        };
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post("tracks/" + this.track.id + "/sources", params)
            .then(function (response) {
        })
            .catch(function (response) {
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", Object)
    ], PageTrackEditDialogSource.prototype, "track", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Boolean)
    ], PageTrackEditDialogSource.prototype, "value", void 0);
    PageTrackEditDialogSource = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageTrackEditDialogSource);
    return PageTrackEditDialogSource;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageTrackEditDialogSource);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var PageUser = (function (_super) {
    __extends(PageUser, _super);
    function PageUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.user = null;
        _this.activeTab = "home";
        _this.tabs = [
            { id: "home", text: "Home" },
            { id: "playlists", text: "Playlists" },
            { id: "channels", text: "Channels" },
        ];
        return _this;
    }
    PageUser.prototype.created = function () {
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", String)
    ], PageUser.prototype, "id", void 0);
    PageUser = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageUser);
    return PageUser;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageUser);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PageUserChannels = (function (_super) {
    __extends(PageUserChannels, _super);
    function PageUserChannels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageUserChannels = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageUserChannels);
    return PageUserChannels;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageUserChannels);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PageUserHome = (function (_super) {
    __extends(PageUserHome, _super);
    function PageUserHome() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageUserHome = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PageUserHome);
    return PageUserHome;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageUserHome);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaser__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var PageUserPlaylists = (function (_super) {
    __extends(PageUserPlaylists, _super);
    function PageUserPlaylists() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.playlists = [];
        return _this;
    }
    PageUserPlaylists.prototype.created = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get("playlists", { params: { user_id: this.id, with: ["tracks", "tracks.sources"] } })
            .then(function (response) {
            _this.playlists = response.data.data;
        })
            .catch(function (response) {
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", String)
    ], PageUserPlaylists.prototype, "id", void 0);
    PageUserPlaylists = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                PlaylistTeaser: __WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaser___default.a,
            }
        })
    ], PageUserPlaylists);
    return PageUserPlaylists;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageUserPlaylists);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchResultsMyouseek__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchResultsMyouseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SearchResultsMyouseek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchResultsYoutube__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchResultsYoutube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchResultsYoutube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResultsSoundcloud__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResultsSoundcloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchResultsSoundcloud__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var PageSearch = (function (_super) {
    __extends(PageSearch, _super);
    function PageSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabs = [
            { id: "meyouseek", text: "meyouseek", }
        ];
        _this.activeTab = "meyouseek";
        return _this;
    }
    PageSearch.prototype.onRouteChanged = function () {
        this.activeTab = "meyouseek";
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])(),
        __metadata("design:type", String)
    ], PageSearch.prototype, "q", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageSearch.prototype, "onRouteChanged", null);
    PageSearch = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                "meyouseek": __WEBPACK_IMPORTED_MODULE_2__SearchResultsMyouseek___default.a,
                "youtube": __WEBPACK_IMPORTED_MODULE_3__SearchResultsYoutube___default.a,
                "soundcloud": __WEBPACK_IMPORTED_MODULE_4__SearchResultsSoundcloud___default.a,
            },
        })
    ], PageSearch);
    return PageSearch;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageSearch);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AudioTeaser__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AudioTeaser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AudioTeaser__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var SearchResultsMyouseek = (function (_super) {
    __extends(SearchResultsMyouseek, _super);
    function SearchResultsMyouseek() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.audios = [];
        return _this;
    }
    SearchResultsMyouseek.prototype.getTracks = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get('audios', { params: { q: this.$route.params.q } })
            .then(function (response) {
            _this.audios = response.data.data;
            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.audios)) {
                _this.$emit("next");
            }
        })
            .catch(function (response) {
        });
    };
    SearchResultsMyouseek.prototype.onRouteChanged = function () {
        this.getTracks();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])('$route', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchResultsMyouseek.prototype, "onRouteChanged", null);
    SearchResultsMyouseek = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                AudioTeaser: __WEBPACK_IMPORTED_MODULE_4__components_AudioTeaser___default.a,
            }
        })
    ], SearchResultsMyouseek);
    return SearchResultsMyouseek;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (SearchResultsMyouseek);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var SearchResultsSoundcloud = (function (_super) {
    __extends(SearchResultsSoundcloud, _super);
    function SearchResultsSoundcloud() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchResultsSoundcloud.prototype.created = function () {
    };
    SearchResultsSoundcloud = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], SearchResultsSoundcloud);
    return SearchResultsSoundcloud;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (SearchResultsSoundcloud);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var SearchResultsYoutube = (function (_super) {
    __extends(SearchResultsYoutube, _super);
    function SearchResultsYoutube() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchResultsYoutube.prototype.created = function () {
    };
    SearchResultsYoutube = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], SearchResultsYoutube);
    return SearchResultsYoutube;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (SearchResultsYoutube);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Inputs_InputAudioTags__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Inputs_InputAudioTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Inputs_InputAudioTags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputs_InputTrackArtist__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputs_InputTrackArtist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Inputs_InputTrackArtist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputs_InputTrackTitle__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputs_InputTrackTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Inputs_InputTrackTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputs_InputTrackSource__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputs_InputTrackSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Inputs_InputTrackSource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputs_InputTrackLyricsSource__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputs_InputTrackLyricsSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Inputs_InputTrackLyricsSource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageTitle__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PageTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__decorators_validate__ = __webpack_require__(59);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var PageTracksCreate = (function (_super) {
    __extends(PageTracksCreate, _super);
    function PageTracksCreate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.alert = true;
        _this.form = {
            artist: "",
            name: "",
            previewSource: "",
            lyricsSource: "",
            tags: [],
        };
        _this.providerTitle = "";
        return _this;
    }
    PageTracksCreate.prototype.swap = function () {
        _a = [this.form.name, this.form.artist], this.form.artist = _a[0], this.form.name = _a[1];
        var _a;
    };
    PageTracksCreate.prototype.autoFill = function (title) {
        this.providerTitle = title;
        var matches = title.match(/(.*)\s-\s(.*)/);
        this.form.artist = matches[1];
        this.form.name = matches[2];
    };
    PageTracksCreate.prototype.submit = function () {
        var _this = this;
        var params = this["$deepcopy"](this.form);
        params.tags = params.tags.map(function (tag) {
            return typeof tag === 'object' ? tag.name : tag;
        });
        params.type = "track";
        __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('audios', params).then(function (response) {
            _this.$router.push({ name: 'Track', params: { id: response.data.id } });
        }, function (response) {
        });
    };
    PageTracksCreate.prototype.created = function () {
        this.form.previewSource = this.$route.query.previewSource || "";
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_9__decorators_validate__["a" /* default */],
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageTracksCreate.prototype, "submit", null);
    PageTracksCreate = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                PageTitle: __WEBPACK_IMPORTED_MODULE_8__components_PageTitle___default.a,
                InputAudioTags: __WEBPACK_IMPORTED_MODULE_3__components_Inputs_InputAudioTags___default.a,
                "input-track-artist": __WEBPACK_IMPORTED_MODULE_4__components_Inputs_InputTrackArtist___default.a,
                "input-track-title": __WEBPACK_IMPORTED_MODULE_5__components_Inputs_InputTrackTitle___default.a,
                "input-track-source": __WEBPACK_IMPORTED_MODULE_6__components_Inputs_InputTrackSource___default.a,
                "input-track-lyrics-source": __WEBPACK_IMPORTED_MODULE_7__components_Inputs_InputTrackLyricsSource___default.a,
            }
        })
    ], PageTracksCreate);
    return PageTracksCreate;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PageTracksCreate);


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaserImage__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaserImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaserImage__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PlaylistTeaser = (function (_super) {
    __extends(PlaylistTeaser, _super);
    function PlaylistTeaser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Object)
    ], PlaylistTeaser.prototype, "playlist", void 0);
    PlaylistTeaser = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                PlaylistTeaserImage: __WEBPACK_IMPORTED_MODULE_2__components_PlaylistTeaserImage___default.a,
            }
        })
    ], PlaylistTeaser);
    return PlaylistTeaser;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PlaylistTeaser);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var PlaylistImage = (function (_super) {
    __extends(PlaylistImage, _super);
    function PlaylistImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PlaylistImage.prototype, "src", {
        get: function () {
            if (this.playlist.audios.length) {
                return this.playlist.audios[0].imgSource;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ required: true }),
        __metadata("design:type", Object)
    ], PlaylistImage.prototype, "playlist", void 0);
    PlaylistImage = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PlaylistImage);
    return PlaylistImage;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PlaylistImage);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Test = (function (_super) {
    __extends(Test, _super);
    function Test() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.items = ["first", "second"];
        _this.selected = "first";
        _this.isMounted = false;
        _this.customHTML = "<img src=\"https://vuetifyjs.com/static/doc-images/carousel/planet.jpg\">";
        return _this;
    }
    Test.prototype.test = function () {
    };
    Test.prototype.create = function () {
        console.log(this.$refs.mySelect["searchValue"]);
    };
    Test.prototype.mounted = function () {
        this.isMounted = true;
        console.log(this);
    };
    Test = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Test);
    return Test;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Test);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TheHeaderLogo__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TheHeaderLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TheHeaderLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TheHeaderSearchBar__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TheHeaderSearchBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TheHeaderSearchBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TheHeaderSearchLarge__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TheHeaderSearchLarge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TheHeaderSearchLarge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TheHeaderMenuApps__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TheHeaderMenuApps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TheHeaderMenuApps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TheHeaderMenuProfile__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TheHeaderMenuProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TheHeaderMenuProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DialogAuth__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DialogAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_DialogAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var TheHeader = (function (_super) {
    __extends(TheHeader, _super);
    function TheHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    Object.defineProperty(TheHeader.prototype, "isAuthenticated", {
        get: function () {
            return this.$store.state.user.isAuthenticated;
        },
        enumerable: true,
        configurable: true
    });
    ;
    TheHeader.prototype.demoGetToken = function () {
        var _this = this;
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_8__http__["a" /* default */].get('token').then(function (response) {
            _this.demoLogin(response);
            _this.isLoading = false;
        }, function (response) {
            _this.isLoading = false;
        });
    };
    TheHeader.prototype.demoLogin = function (response) {
        var _this = this;
        var data = {
            client_id: 2,
            client_secret: response.data,
            grant_type: 'password',
            username: "demo@demo.demo",
            password: "demo",
        };
        var axiosConfigUrl = "http://" + window.location.hostname + ":4562/" + "oauth/token";
        if (window.location.hostname === 'myouseek.com') {
            axiosConfigUrl = 'https://api.' + window.location.hostname + "/oauth/token";
        }
        __WEBPACK_IMPORTED_MODULE_8__http__["a" /* default */].post(axiosConfigUrl, data).then(function (response) {
            _this["$auth"].setToken(response.data.access_token, response.data.expires_in + Date.now() + 15 * 24 * 60 * 60 * 1000);
            _this.$router.push("/");
            location.reload();
        }, function (response) {
            _this.isLoading = false;
        });
    };
    TheHeader = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                "search-lg": __WEBPACK_IMPORTED_MODULE_4__TheHeaderSearchLarge___default.a,
                "search": __WEBPACK_IMPORTED_MODULE_3__TheHeaderSearchBar___default.a,
                "logo": __WEBPACK_IMPORTED_MODULE_2__TheHeaderLogo___default.a,
                "menu-apps": __WEBPACK_IMPORTED_MODULE_5__TheHeaderMenuApps___default.a,
                "menu-profile": __WEBPACK_IMPORTED_MODULE_6__TheHeaderMenuProfile___default.a,
                DialogAuth: __WEBPACK_IMPORTED_MODULE_7__components_DialogAuth___default.a,
            },
        })
    ], TheHeader);
    return TheHeader;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheHeader);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var TheHeaderLogo = (function (_super) {
    __extends(TheHeaderLogo, _super);
    function TheHeaderLogo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TheHeaderLogo = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], TheHeaderLogo);
    return TheHeaderLogo;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheHeaderLogo);


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var TheHeaderMenuApps = (function (_super) {
    __extends(TheHeaderMenuApps, _super);
    function TheHeaderMenuApps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TheHeaderMenuApps = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], TheHeaderMenuApps);
    return TheHeaderMenuApps;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheHeaderMenuApps);


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var TheHeaderMenuProfile = (function (_super) {
    __extends(TheHeaderMenuProfile, _super);
    function TheHeaderMenuProfile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.user = _this.$store.state.user.user;
        return _this;
    }
    TheHeaderMenuProfile = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], TheHeaderMenuProfile);
    return TheHeaderMenuProfile;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheHeaderMenuProfile);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var TheHeaderSearchBar = (function (_super) {
    __extends(TheHeaderSearchBar, _super);
    function TheHeaderSearchBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.q = '';
        _this.suggestions = [];
        return _this;
    }
    TheHeaderSearchBar.prototype.show = function () {
    };
    TheHeaderSearchBar.prototype.hide = function () {
    };
    TheHeaderSearchBar.prototype.select = function (q) {
    };
    TheHeaderSearchBar.prototype.clear = function () {
        this.q = '';
    };
    TheHeaderSearchBar.prototype.submit = function () {
        this.$router.push({ name: 'Search', query: { q: this.q } });
    };
    TheHeaderSearchBar = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], TheHeaderSearchBar);
    return TheHeaderSearchBar;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheHeaderSearchBar);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Search = (function (_super) {
    __extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.q = "";
        return _this;
    }
    Search.prototype.submit = function () {
        if (this.q) {
            this.$router.push({ name: 'Search', params: { q: this.q } });
        }
    };
    Search = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Search);
    return Search;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Search);


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__section__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__section___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__section__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var TheLeftSidebar = (function (_super) {
    __extends(TheLeftSidebar, _super);
    function TheLeftSidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.user = _this.$store.state.user;
        _this.drawer = _this["$vuetify"].breakpoint.lgAndUp;
        _this.dark = false;
        _this.showMore = false;
        return _this;
    }
    TheLeftSidebar.prototype.toggleTheme = function () {
        var _this = this;
        this.dark = !this.dark;
        this.$nextTick(function () {
            _this.$emit('update:dark', _this.dark);
            localStorage.setItem('theme', _this.dark ? "dark" : "light");
        });
    };
    TheLeftSidebar.prototype.onDrawerChanged = function (newVal) {
        this["$store"].commit("setDrawer", newVal);
    };
    TheLeftSidebar.prototype.onRouteChange = function () {
        if (["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name)) {
            this.drawer = false;
        }
    };
    TheLeftSidebar.prototype.created = function () {
        if (this["$vuetify"].breakpoint.lgAndUp) {
            this.drawer = this.$store.state.drawer;
        }
        this.dark = "dark" === localStorage.getItem('theme');
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("drawer"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TheLeftSidebar.prototype, "onDrawerChanged", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TheLeftSidebar.prototype, "onRouteChange", null);
    TheLeftSidebar = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                "ls-section": __WEBPACK_IMPORTED_MODULE_2__section___default.a,
            },
        })
    ], TheLeftSidebar);
    return TheLeftSidebar;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheLeftSidebar);


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var TheLeftSidebarSection = (function (_super) {
    __extends(TheLeftSidebarSection, _super);
    function TheLeftSidebarSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TheLeftSidebarSection = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], TheLeftSidebarSection);
    return TheLeftSidebarSection;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheLeftSidebarSection);


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBuses_ThePlayerEventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AppPlayer = (function (_super) {
    __extends(AppPlayer, _super);
    function AppPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = _this.$store.state.player;
        return _this;
    }
    Object.defineProperty(AppPlayer.prototype, "audioElement", {
        get: function () {
            return this.$refs["audio"];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppPlayer.prototype, "src", {
        get: function () {
            if (!this.$store.getters.audio)
                return null;
            if (this.$store.getters.audio.previewSource.provider !== "meyouseek")
                return null;
            return "https://myouseek.com/audio/" + this.$store.getters.audio.previewSource.provider_id + ".mp3";
        },
        enumerable: true,
        configurable: true
    });
    AppPlayer.prototype.calculateBuffered = function () {
        var audioElement = this.audioElement;
        var buffered = 0;
        if (audioElement.buffered.length) {
            var x = 0;
            while (x < audioElement.buffered.length && audioElement.buffered.start(x) < audioElement.currentTime) {
                ++x;
            }
            if (x < 1)
                x = 1;
            buffered = audioElement.buffered.end(x - 1);
        }
        return buffered;
    };
    AppPlayer.prototype.mounted = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__EventBuses_ThePlayerEventBus__["a" /* default */].$on("seekTo", function (time) {
            if (_this.$store.getters.audio.provider !== "meyouseek")
                return;
            _this.audioElement.currentTime = time;
        });
        this.audioElement.addEventListener("durationchange", function (e) {
            _this.$store.dispatch("setDuration", _this.audioElement.duration);
        });
        this.audioElement.addEventListener("timeupdate", function (e) {
            _this.$store.dispatch("setTime", _this.audioElement.currentTime);
            _this.$store.dispatch("setBuffered", _this.calculateBuffered());
        });
    };
    AppPlayer.prototype.onSrcChange = function (newSrc) {
        if (!newSrc)
            this.audioElement.pause();
        this.audioElement.load();
    };
    AppPlayer.prototype.onStateChange = function (newState, oldState) {
        var _this = this;
        if (newState === oldState)
            return;
        if (!this.src)
            return;
        if (newState === 1) {
            if (oldState === 0) {
                this.audioElement.currentTime = 0;
            }
            setTimeout(function () {
                _this.audioElement.play();
            });
        }
        else if (newState === 0) {
            this.audioElement.pause();
        }
        else if (newState === 2) {
            this.audioElement.pause();
        }
    };
    AppPlayer.prototype.onAudioChange = function (id) {
        if (!this.$store.state.user)
            return;
        __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post("/views", { audio_id: id })
            .then(function (response) {
        })
            .catch(function (response) {
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("src"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppPlayer.prototype, "onSrcChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AppPlayer.prototype, "onStateChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$store.getters.audio.id"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppPlayer.prototype, "onAudioChange", null);
    AppPlayer = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], AppPlayer);
    return AppPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (AppPlayer);


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThePlayerExternalPlayer__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThePlayerExternalPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ThePlayerExternalPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThePlayerProgressBar__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThePlayerProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ThePlayerProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThePlayerAudioInfo__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThePlayerAudioInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ThePlayerAudioInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThePlayerControls__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThePlayerControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ThePlayerControls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThePlayerCurrentPlaylist__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThePlayerCurrentPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ThePlayerCurrentPlaylist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EventBuses_ThePlayerEventBus__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var ThePlayer = (function (_super) {
    __extends(ThePlayer, _super);
    function ThePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        _this.room = "";
        _this.player = _this.$store.state.player;
        return _this;
    }
    ThePlayer.prototype.joinRoom = function () {
        this["$socket"].emit("join room", this.room);
    };
    ThePlayer.prototype.onStateChange = function (newVal, oldVal) {
        var player = this.player;
    };
    ThePlayer.prototype.onPositionChange = function (newPosition, oldPosition) {
        var _this = this;
        if (this.player.alteringPlaylist)
            return;
        this.$store.dispatch("setState", 0);
        __WEBPACK_IMPORTED_MODULE_8__EventBuses_ThePlayerEventBus__["a" /* default */].$emit("seekTo", 0);
        this.$nextTick(function () {
            _this.$store.dispatch("setState", 1);
        });
    };
    ThePlayer.prototype.onTimeChange = function (newTime) {
        if (newTime && newTime === this.player.duration) {
            if (this.player.repeat === 1) {
                __WEBPACK_IMPORTED_MODULE_8__EventBuses_ThePlayerEventBus__["a" /* default */].$emit("seekTo", 0);
            }
            else if ((__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.last(this.player.playlist)["id"] === this.$store.getters.audio.id) && (this.player.repeat === 2)) {
                this.$store.dispatch("setPosition", 0);
            }
            else if (this.player.position < this.player.playlist.length - 1) {
                this.$store.dispatch("setPosition", this.player.position + 1);
            }
            else {
                this.$store.dispatch("setState", 0);
            }
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayer.prototype, "onStateChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.position"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayer.prototype, "onPositionChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.time"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayer.prototype, "onTimeChange", null);
    ThePlayer = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                "external-player": __WEBPACK_IMPORTED_MODULE_2__ThePlayerExternalPlayer___default.a,
                "player-progress-bar": __WEBPACK_IMPORTED_MODULE_3__ThePlayerProgressBar___default.a,
                "player-info": __WEBPACK_IMPORTED_MODULE_4__ThePlayerAudioInfo___default.a,
                "player-controls": __WEBPACK_IMPORTED_MODULE_5__ThePlayerControls___default.a,
                "current-playlist": __WEBPACK_IMPORTED_MODULE_6__ThePlayerCurrentPlaylist___default.a,
            },
            sockets: {
                "connect": function () {
                },
                "join": function (user) {
                },
                "leave": function (user) {
                },
                "message": function (message) {
                }
            },
        })
    ], ThePlayer);
    return ThePlayer;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ThePlayer);


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ButtonLikeAudio__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ButtonLikeAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ButtonLikeAudio__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ThePlayerAudioInfo = (function (_super) {
    __extends(ThePlayerAudioInfo, _super);
    function ThePlayerAudioInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = _this.$store.state.player;
        return _this;
    }
    Object.defineProperty(ThePlayerAudioInfo.prototype, "audio", {
        get: function () {
            return this.$store.getters.audio;
        },
        enumerable: true,
        configurable: true
    });
    ThePlayerAudioInfo = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                ButtonLikeAudio: __WEBPACK_IMPORTED_MODULE_2__components_ButtonLikeAudio___default.a,
            }
        })
    ], ThePlayerAudioInfo);
    return ThePlayerAudioInfo;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ThePlayerAudioInfo);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snackbarBus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBuses_ThePlayerEventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var ThePlayerControls = (function (_super) {
    __extends(ThePlayerControls, _super);
    function ThePlayerControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = _this.$store.state.player;
        return _this;
    }
    ThePlayerControls.prototype.play = function () {
        this.$store.dispatch("play");
    };
    ThePlayerControls.prototype.pause = function () {
        this.$store.dispatch("pause");
    };
    ThePlayerControls.prototype.toggleRepeat = function () {
        if (this.player.repeat === 2) {
            this.$store.dispatch('setRepeat', 0);
        }
        else {
            this.$store.dispatch('setRepeat', this.player.repeat + 1);
        }
    };
    Object.defineProperty(ThePlayerControls.prototype, "isPlaylingLast", {
        get: function () {
            if (!this.player.playlist)
                return false;
            return this.player.position === this.player.playlist.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThePlayerControls.prototype, "canNext", {
        get: function () {
            if (!this.player.playlist.length)
                return false;
            return this.player.repeat === 2 || !this.isPlaylingLast;
        },
        enumerable: true,
        configurable: true
    });
    ThePlayerControls.prototype.playNext = function () {
        if (this.player.repeat === 2 && this.isPlaylingLast) {
            this.$store.dispatch("setPosition", 0);
        }
        else {
            this.$store.dispatch("setPosition", this.player.position + 1);
        }
    };
    ThePlayerControls.prototype.playPrevious = function () {
        if (this.player.position === 0) {
            __WEBPACK_IMPORTED_MODULE_3__EventBuses_ThePlayerEventBus__["a" /* default */].$emit("seekTo", 0);
        }
        else {
            this.$store.dispatch("setPosition", this.player.position - 1);
        }
    };
    ThePlayerControls.prototype.onRepeatChange = function (val) {
        if (val === 0) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "Repeat is off");
        }
        else if (val === 1) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "Repeat track is on");
        }
        else if (val === 2) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "Loop playlist is on");
        }
    };
    ThePlayerControls.prototype.onShuffleChange = function (shuffle) {
        if (shuffle) {
            __WEBPACK_IMPORTED_MODULE_2__snackbarBus__["a" /* default */].$emit("show", "Playlist shuffled");
            var part1 = this.player.playlist.slice(0, this.player.position + 1);
            var part2 = this.player.playlist.slice(this.player.position + 1);
            var shuffled = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.shuffle(part2);
            this.$store.dispatch("setPlaylist", __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.concat(part1, shuffled));
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.repeat"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerControls.prototype, "onRepeatChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.shuffle"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerControls.prototype, "onShuffleChange", null);
    ThePlayerControls = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ThePlayerControls);
    return ThePlayerControls;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ThePlayerControls);


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var ThePlayerCurrentPlaylist = (function (_super) {
    __extends(ThePlayerCurrentPlaylist, _super);
    function ThePlayerCurrentPlaylist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menu = false;
        _this.player = _this.$store.state.player;
        _this.playlist = [];
        _this.audios = [];
        _this.draggableOptions = {
            disabled: false,
            handle: '.handle',
            ghostClass: 'ghost',
            setData: function (dataTransfer) {
                dataTransfer.setDragImage(document.createElement('div'), 0, 0);
            },
        };
        return _this;
    }
    ThePlayerCurrentPlaylist.prototype.onPlayerPlaylistChange = function (p) {
        this.playlist = p;
        this.$refs.menu["updateDimensions"]();
    };
    ThePlayerCurrentPlaylist.prototype.onDragStart = function () {
        this.$store.dispatch("setAlteringPlaylist", true);
    };
    ThePlayerCurrentPlaylist.prototype.onDragEnd = function (e) {
        var _this = this;
        if (e.oldIndex === this.player.position) {
            this.$store.dispatch("setPosition", e.newIndex);
        }
        else if (e.newIndex <= this.player.position && e.oldIndex > this.player.position) {
            this.$store.dispatch("setPosition", this.player.position + 1);
        }
        else if (e.newIndex >= this.player.position && e.oldIndex < this.player.position) {
            this.$store.dispatch("setPosition", this.player.position - 1);
        }
        this.$store.dispatch("setPlaylist", this.playlist);
        this.$nextTick(function () {
            _this.$store.dispatch("setAlteringPlaylist", false);
        });
    };
    ThePlayerCurrentPlaylist.prototype.remove = function (index) {
        var _this = this;
        this.$store.dispatch("setAlteringPlaylist", true);
        this.$store.dispatch("playlistPull", index);
        if (index <= this.player.position) {
            this.$store.dispatch("setPosition", this.player.position - 1);
        }
        this.$nextTick(function () {
            _this.$store.dispatch("setAlteringPlaylist", false);
        });
    };
    ThePlayerCurrentPlaylist.prototype.clearPlaylist = function () {
        var _this = this;
        this.$store.dispatch("setAlteringPlaylist", true);
        this.$store.dispatch("setPlaylist", [this.$store.getters.audio]);
        this.$store.dispatch("setPosition", 0);
        this.$nextTick(function () {
            _this.$store.dispatch("setAlteringPlaylist", false);
        });
        setTimeout(function () {
            _this.$refs.menu["updateDimensions"]();
        }, 501);
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.playlist", { deep: true, }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerCurrentPlaylist.prototype, "onPlayerPlaylistChange", null);
    ThePlayerCurrentPlaylist = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                AudioImg: __WEBPACK_IMPORTED_MODULE_2__components_AudioImageWithOverlay___default.a,
                draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
            }
        })
    ], ThePlayerCurrentPlaylist);
    return ThePlayerCurrentPlaylist;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ThePlayerCurrentPlaylist);


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__YoutubePlayer__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__YoutubePlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__YoutubePlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppPlayer__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AppPlayer__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var ThePlayerExternalPlayer = (function (_super) {
    __extends(ThePlayerExternalPlayer, _super);
    function ThePlayerExternalPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.show = false;
        _this.player = _this.$store.state.player;
        return _this;
    }
    ThePlayerExternalPlayer.prototype.toggleShow = function () {
    };
    ThePlayerExternalPlayer.prototype.created = function () {
        this.$store.dispatch("pause");
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$vuetify.breakpoint.name", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ThePlayerExternalPlayer.prototype, "toggleShow", null);
    ThePlayerExternalPlayer = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: {
                YoutubePlayer: __WEBPACK_IMPORTED_MODULE_2__YoutubePlayer___default.a,
                AppPlayer: __WEBPACK_IMPORTED_MODULE_3__AppPlayer___default.a,
            }
        })
    ], ThePlayerExternalPlayer);
    return ThePlayerExternalPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ThePlayerExternalPlayer);


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBuses_ThePlayerEventBus__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ThePlayerProgressBar = (function (_super) {
    __extends(ThePlayerProgressBar, _super);
    function ThePlayerProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buffer = 0;
        _this.bufferValue = 0;
        _this.tooltipTime = "";
        _this.player = _this.$store.state.player;
        return _this;
    }
    ThePlayerProgressBar.prototype.onClick = function (e) {
        var target = e.target.parentElement.parentElement;
        var totalWidth = target.offsetWidth;
        var clickedWidth = e.offsetX;
        var percentageClicked = (clickedWidth / totalWidth);
        __WEBPACK_IMPORTED_MODULE_2__EventBuses_ThePlayerEventBus__["a" /* default */].$emit("seekTo", percentageClicked * this.player.duration);
    };
    ThePlayerProgressBar.prototype.formatTime = function (time) {
        time = Math.round(time);
        var minutes = Math.floor(time / 60), seconds = time - minutes * 60, sSeconds = seconds < 10 ? "0" + seconds : seconds;
        return minutes + ":" + sSeconds;
    };
    ThePlayerProgressBar.prototype.showTime = function (e) {
        if (!this.$store.getters.audio) {
            return;
        }
        var target = e.target.parentElement.parentElement, totalWidth = target.offsetWidth, clickedWidth = e.offsetX, percentageHovered = (clickedWidth / totalWidth) * 100;
        this.tooltipTime = this.formatTime((percentageHovered / 100) * this.player.duration);
        this.$refs.time["style"].display = "block";
        var tooltipWidth = 60;
        if (e.offsetX > tooltipWidth / 2 && e.offsetX < totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = e.offsetX - tooltipWidth / 2 + "px";
        }
        else if (e.offsetX <= tooltipWidth / 2) {
            this.$refs.time["style"].left = 0;
        }
        else if (e.offsetX > totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = totalWidth - tooltipWidth + "px";
        }
    };
    ThePlayerProgressBar.prototype.hideTime = function (e) {
        this.$refs.time["style"].display = "none";
    };
    ThePlayerProgressBar.prototype.onTimeChange = function (newTime, oldTime) {
        this.buffer = (newTime / this.player.duration) * 100;
    };
    ThePlayerProgressBar.prototype.onBufferedChange = function (newVal) {
        this.bufferValue = 100 * (newVal / this.player.duration);
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.time"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerProgressBar.prototype, "onTimeChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.buffered"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerProgressBar.prototype, "onBufferedChange", null);
    ThePlayerProgressBar = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ThePlayerProgressBar);
    return ThePlayerProgressBar;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ThePlayerProgressBar);


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_youtube_iframe__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_youtube_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_youtube_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBuses_ThePlayerEventBus__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var YoutubePlayer = (function (_super) {
    __extends(YoutubePlayer, _super);
    function YoutubePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = _this.$store.state.player;
        _this.YTPlayer = null;
        _this.YTPlayerState = -1;
        return _this;
    }
    YoutubePlayer.prototype.onPlayerReady = function (event) {
        var _this = this;
        this.YTPlayer = event.target;
        this.updateProgress();
        var time_update_interval;
        clearInterval(time_update_interval);
        time_update_interval = setInterval(function () {
            _this.updateProgress();
        }, 300);
    };
    YoutubePlayer.prototype.updateProgress = function () {
        if (!this.YTPlayer.getDuration())
            return;
        var percentageLoaded = this.YTPlayer.getVideoBytesLoaded() * 100;
        this.$store.dispatch("setTime", this.YTPlayer.getCurrentTime());
        this.$store.dispatch("setBuffered", this.YTPlayer.getVideoBytesLoaded() * this.player.duration);
    };
    YoutubePlayer.prototype.created = function () {
        var _this = this;
        var player;
        __WEBPACK_IMPORTED_MODULE_2_youtube_iframe___default.a.load(function (YT) {
            player = new YT.Player('youtube-player', {
                height: '225',
                width: '300',
                events: {
                    'onReady': _this.onPlayerReady,
                    'onStateChange': function (val) {
                        _this.YTPlayerState = val.data;
                        _this.$store.dispatch("setDuration", _this.YTPlayer.getDuration());
                    },
                },
                playerVars: {
                    'autoplay': 0,
                    'controls': 0,
                    'rel': 0,
                    'fs': 0,
                }
            });
        });
        __WEBPACK_IMPORTED_MODULE_3__EventBuses_ThePlayerEventBus__["a" /* default */].$on("seekTo", function (time) {
            if (_this.$store.getters.audio.provider !== "youtube")
                return;
            _this.YTPlayer.seekTo(time);
        });
    };
    YoutubePlayer.prototype.onPositionChange = function () {
        if (this.player.alteringPlaylist)
            return;
        if (this.$store.getters.audio.provider !== "youtube") {
            this.YTPlayer.stopVideo();
        }
    };
    YoutubePlayer.prototype.onAudioChange = function (newAudio, oldAudio) {
        if (oldAudio && (newAudio && (newAudio.id === oldAudio.id)))
            return;
        if (!newAudio)
            return;
        if (newAudio.provider === "youtube") {
            this.YTPlayer.loadVideoById(newAudio.providerId);
            this.YTPlayer.playVideo();
        }
    };
    YoutubePlayer.prototype.onStateChanged = function (newState, oldState) {
        var _this = this;
        if (newState === oldState)
            return;
        if (this.$store.getters.audio && this.$store.getters.audio.provider !== "youtube")
            return;
        this.$nextTick(function () {
            if (newState === 1) {
                _this.YTPlayer.playVideo();
            }
            else {
                if (_this.YTPlayer.getPlayerState() === 1) {
                    _this.YTPlayer.pauseVideo();
                }
            }
        });
    };
    YoutubePlayer.prototype.onYTPlayerStateChange = function (newState) {
        return;
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.position", { immediate: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onPositionChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$store.getters.audio", { immediate: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onAudioChange", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onStateChanged", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("YTPlayerState"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onYTPlayerStateChange", null);
    YoutubePlayer = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], YoutubePlayer);
    return YoutubePlayer;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (YoutubePlayer);


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var TheRightSidebar = (function (_super) {
    __extends(TheRightSidebar, _super);
    function TheRightSidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _this.$store.state;
        _this.drawer = _this.$vuetify.breakpoint.lgAndUp;
        _this.tracks = ["first", "second", "third"];
        _this.show = false;
        return _this;
    }
    TheRightSidebar.prototype.toggleShow = function () {
        this.show = !["xs", "sm"].includes(this.$vuetify.breakpoint.name);
    };
    TheRightSidebar.prototype.onDrawerChanged = function (newVal) {
        this["$store"].commit("setRightSidebar", newVal);
    };
    TheRightSidebar.prototype.onRouteChange = function () {
        if (["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name)) {
            this.drawer = false;
        }
    };
    TheRightSidebar.prototype.created = function () {
        if (this.$vuetify.breakpoint.lgAndUp) {
            this.drawer = this["$store"].state.drawer;
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$vuetify.breakpoint.name", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TheRightSidebar.prototype, "toggleShow", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("drawer"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TheRightSidebar.prototype, "onDrawerChanged", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("$route"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TheRightSidebar.prototype, "onRouteChange", null);
    TheRightSidebar = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({})
    ], TheRightSidebar);
    return TheRightSidebar;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TheRightSidebar);


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timeago_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timeago_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_timeago_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_auth_Auth__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_snackbar_index__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_socket_io__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stylus_main_styl__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Layouts_LayoutPage__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Layouts_LayoutPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Layouts_LayoutPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AppBtn__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AppBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_AppBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AppGridList__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AppGridList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_AppGridList__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$timeago = __WEBPACK_IMPORTED_MODULE_4_timeago_js___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$nFormat = function (number) {
    var SI_POSTFIXES = ["", "k", "M", "G", "T", "P", "E"];
    var tier = Math.log10(Math.abs(number)) / 3 | 0;
    if (tier == 0)
        return number;
    var postfix = SI_POSTFIXES[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;
    var formatted = scaled.toFixed(1) + '';
    if (/\.0$/.test(formatted))
        formatted = formatted.substr(0, formatted.length - 2);
    return formatted + postfix;
};


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__packages_auth_Auth__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__packages_snackbar_index__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_socket_io___default.a, ':3000');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuetify___default.a, {
    theme: {
        primary: "#1976d2",
        secondary: "#fb8c00",
        accent: "#ff5252",
        info: "#42a5f5",
        warning: "#ffa000",
        error: "#d50000",
        success: "#81c784",
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout-page', __WEBPACK_IMPORTED_MODULE_11__components_Layouts_LayoutPage___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-btn', __WEBPACK_IMPORTED_MODULE_12__components_AppBtn___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-grid-list', __WEBPACK_IMPORTED_MODULE_13__components_AppGridList___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
    if ((to.matched[0].meta.length === 0)) {
        return next();
    }
    if (to.matched[0].meta.forAuth) {
        if (!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].auth.isAuthenticated()) {
            return next({ path: "/login" });
        }
    }
    if (to.matched[0].meta.forAuth === false) {
        if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].auth.isAuthenticated()) {
            return next({ path: "/" });
        }
    }
    return next();
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$deepcopy = function (o) {
    return JSON.parse(JSON.stringify(o));
};
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    render: function (h) { return h(__WEBPACK_IMPORTED_MODULE_1__App_vue___default.a); }
});


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    state: 0,
    time: 0,
    duration: 0,
    buffered: 0,
    repeat: 0,
    shuffle: false,
    position: null,
    playlist: [],
    provider: "",
    alteringPlaylist: false,
};
var getters = {
    audio: function (state) {
        return state.playlist[state.position];
    }
};
var actions = {
    playAudio: function (_a, audio, playlist, position) {
        var commit = _a.commit, getters = _a.getters;
        if (playlist === void 0) { playlist = null; }
        if (position === void 0) { position = 0; }
        audio = JSON.parse(JSON.stringify(audio));
        if (playlist) {
            commit("SET_PLAYLIST", playlist.audios);
            commit("SET_POSITION", position);
        }
        else {
            if (!getters.audio || getters.audio.id !== audio.id) {
                commit("PLAYLIST_PUSH", audio);
                commit("SET_POSITION", state.playlist.length - 1);
            }
            else if (getters.audio && (getters.audio.id === audio.id)) {
                commit('SET_STATE', 1);
            }
        }
    },
    play: function (_a) {
        var commit = _a.commit;
        commit('SET_STATE', 1);
    },
    pause: function (_a) {
        var commit = _a.commit;
        commit('SET_STATE', 2);
    },
    setShuffle: function (_a, shuffle) {
        var commit = _a.commit;
        commit('SET_SHUFFLE', shuffle);
    },
    toggleShuffle: function (_a) {
        var commit = _a.commit;
        commit('TOGGLE_SHUFFLE');
    },
    setRepeat: function (_a, repeat) {
        var commit = _a.commit;
        commit('SET_REPEAT', repeat);
    },
    setState: function (_a, s) {
        var commit = _a.commit;
        commit('SET_STATE', s);
    },
    setPosition: function (_a, position) {
        var commit = _a.commit;
        commit('SET_POSITION', position);
    },
    setTime: function (_a, time) {
        var commit = _a.commit;
        commit('SET_TIME', time);
    },
    setDuration: function (_a, duration) {
        var commit = _a.commit;
        commit('SET_DURATION', duration);
    },
    setBuffered: function (_a, buffered) {
        var commit = _a.commit;
        commit('SET_BUFFERED', buffered);
    },
    setPlaylist: function (_a, playlist) {
        var commit = _a.commit;
        commit('SET_PLAYLIST', playlist);
    },
    setAlteringPlaylist: function (_a, val) {
        var commit = _a.commit;
        commit('SET_ALTERING_PLAYLIST', val);
    },
    playlistPull: function (_a, index) {
        var commit = _a.commit;
        commit('PLAYLIST_PULL', index);
    },
    playlistPush: function (_a, audio) {
        var commit = _a.commit;
        commit('PLAYLIST_PUSH', audio);
    },
};
var mutations = {
    SET_ALTERING_PLAYLIST: function (state, val) {
        state.alteringPlaylist = val;
    },
    SET_PLAYLIST: function (state, playlist) {
        state.playlist = playlist;
    },
    PLAYLIST_PUSH: function (state, audio) {
        state.playlist.push(audio);
        if (state.position === null) {
            state.position = 0;
        }
    },
    PLAYLIST_PULL: function (state, index) {
        state.playlist.splice(index, 1);
    },
    SET_POSITION: function (state, position) {
        state.position = position;
    },
    SET_TIME: function (state, time) {
        state.time = time;
    },
    SET_DURATION: function (state, duration) {
        state.duration = duration;
    },
    SET_BUFFERED: function (state, buffered) {
        state.buffered = buffered;
    },
    SET_STATE: function (state, newPlayerState) {
        state.state = newPlayerState;
    },
    SET_REPEAT: function (state, repeat) {
        state.repeat = repeat;
    },
    SET_SHUFFLE: function (state, shuffle) {
        state.shuffle = shuffle;
    },
    TOGGLE_SHUFFLE: function (state) {
        state.shuffle = !state.shuffle;
    },
};
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});


/***/ }),
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(361),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42a8d606",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(388),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d6442eb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(382),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71a5f05a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(360),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-422dfc2b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(351),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23a528d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(363),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b99cbf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(375),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62d4ea1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(355),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38626a70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(391),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-88a9a68a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(403),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fd4aedb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(341),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06a31e2f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(345),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e3072d9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e33008c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(367),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-543a870e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(352),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28730695",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(386),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79e207c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(353),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2bcf27e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(377),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63eb95d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(358),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-404d760e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(365),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ca82373",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(370),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c877356",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(397),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b866bd00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(368),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57af60b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(387),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7be7ae22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(373),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-600475f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(383),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-745528be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(336),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-011da520",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(362),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43c716f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(399),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d0b3a778",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(343),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0bfde262",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(354),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f1c1082",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(350),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-219c2664",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(374),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61ea96fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(349),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21567cd9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(380),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6dba95d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(396),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad420764",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(348),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b3d2c0b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(359),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4070d079",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(356),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3df983e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(344),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d2dd35f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
  __webpack_require__(170)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(372),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5de4a65c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(401),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d5d4f51a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04120784",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(384),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76f28af8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(357),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e61a1f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(379),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67035470",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(371),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5dbde4a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(395),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abd36e96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(369),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(340),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0670e6cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(347),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16c9891b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(389),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7eadd6f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(337),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-028aa5f1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(400),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d4d74b00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(346),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-116fa487",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(339),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05c627bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9f282666",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(381),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f83f4d9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Edit Track Artist")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "New Artist",
      "required": ""
    },
    model: {
      value: (_vm.artist),
      callback: function($$v) {
        _vm.artist = $$v
      },
      expression: "artist"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "text-xs-center"
  }, [_c('v-flex', [_c('v-btn', {
    ref: "repeat",
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.toggleRepeat
    }
  }, [(_vm.player.repeat === 0) ? _c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("repeat")]) : (_vm.player.repeat === 1) ? _c('v-icon', [_vm._v("repeat_one")]) : _c('v-icon', [_vm._v("repeat")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.playlist.length,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playPrevious
    }
  }, [_c('v-icon', [_vm._v("skip_previous")])], 1), _vm._v(" "), (_vm.player.state !== 1) ? _c('v-btn', {
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "large": "",
      "icon": "",
      "color": "secondary",
      "dark": "",
      "disabled": !_vm.$store.getters.audio
    },
    on: {
      "click": _vm.play
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1) : _c('v-btn', {
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "large": "",
      "icon": "",
      "color": "secondary",
      "dark": ""
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.canNext,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playNext
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('toggleShuffle')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.player.shuffle ? '' : 'grey'
    }
  }, [_vm._v("shuffle")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar-title', {
    staticClass: "ml-0 pl-3",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('span', {
    staticClass: "pl-1"
  }), _vm._v(" "), _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('toggle-drawer')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "white--text hidden-md-and-down",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("MeYouSeek\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "time",
    staticClass: "semi-bold text-xs-center",
    attrs: {
      "id": "time-tooltip"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tooltipTime) + "\n    ")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "grey lighten-2 ma-0 pa-0",
    attrs: {
      "buffer-value": _vm.bufferValue,
      "buffer": "",
      "primary": "",
      "id": "progress-bar",
      "height": "10"
    },
    on: {
      "click": _vm.onClick,
      "mousemove": function($event) {
        _vm.showTime($event)
      },
      "mouseout": function($event) {
        _vm.hideTime($event)
      }
    },
    model: {
      value: (_vm.buffer),
      callback: function($$v) {
        _vm.buffer = $$v
      },
      expression: "buffer"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('audio', {
    ref: "audio",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "controls": ""
    }
  }, [(_vm.$store.getters.audio) ? _c('source', {
    attrs: {
      "src": _vm.src,
      "type": "audio/mpeg"
    }
  }) : _vm._e(), _vm._v("\n            Your browser does not support the audio element.\n        ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "display-1 mb-3"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-combobox', {
    ref: "tags",
    attrs: {
      "multiple": "",
      "value": _vm.value,
      "items": _vm.tags,
      "item-text": "name",
      "item-value": "id",
      "label": "Tags",
      "small-chips": "",
      "deletable-chips": "",
      "return-object": ""
    },
    on: {
      "change": function($event) {
        _vm.$emit('change', $event)
      },
      "input": function($event) {
        _vm.$emit('input', $event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key)) { return null; }
        _vm.updateOnSpace('tags')
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-tabs', {
    attrs: {
      "grow": _vm.$vuetify.breakpoint.smAndDown,
      "slider-color": "primary",
      "color": "transparent"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      attrs: {
        "to": tab.id
      }
    }, [_vm._v("\n                " + _vm._s(tab.text) + "\n            ")])
  })), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-layout', [_c('v-flex', {
    class: {
      'pa-0': _vm.$vuetify.breakpoint.smAndDown
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab-item', {
      key: tab.id,
      attrs: {
        "id": tab.id,
        "lazy": "",
        "transition": false,
        "reverse-transition": false
      }
    }, [_c('router-view', {
      key: tab.id
    })], 1)
  }))], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-media', {
    attrs: {
      "height": "120",
      "src": _vm.src,
      "alt": ""
    }
  }, [_c('v-container', {
    staticClass: " playlist-overlay pa-0 ma-0"
  }, [_c('v-layout', {
    staticClass: " ma-0",
    attrs: {
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("play_arrow")]), _vm._v("\n                Play all\n            ")], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "audio-count"
  }, [_c('v-flex', [_vm._v("\n                Test test test\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_c('v-subheader', [_vm._v("Tracks")]), _vm._v(" "), _c('app-grid-list', _vm._l((_vm.audios), function(audio) {
    return _c('v-flex', {
      key: audio.id,
      attrs: {
        "xs12": "",
        "sm4": "",
        "md3": "",
        "lg2": ""
      }
    }, [_c('audio-teaser', {
      attrs: {
        "audio": audio
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "lg3": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.getters.audio),
      expression: "$store.getters.audio"
    }]
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "outline": "",
      "color": "grey",
      "id": "btn-toggle"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('v-icon', [_vm._v("fullscreen_exit")]) : _c('v-icon', [_vm._v("fullscreen")])], 1)], 1), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.show
    },
    attrs: {
      "id": "external-player"
    }
  }, [_c('youtube-player'), _vm._v(" "), _c('app-player')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    class: {
      'on-top': _vm.$vuetify.breakpoint.lgAndUp
    },
    attrs: {
      "app": "",
      "fixed": "",
      "height": "82"
    }
  }, [_c('external-player'), _vm._v(" "), _c('v-layout', {
    staticClass: "ma-0 justify-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('player-progress-bar')], 1), _vm._v(" "), _c('v-flex', {
    class: {
      'player-disabled': !_vm.player.playlist.length
    },
    staticStyle: {
      "max-height": "72px",
      "min-height": "72px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ma-0 fill-height",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only fill-height",
    staticStyle: {
      "flex": "2 /*so controls are centered*/"
    }
  }, [_c('player-info')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('player-controls')], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    staticStyle: {
      "flex": "2 /*so controls are centered*/"
    }
  }, [_c('current-playlist')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    yt\n")])
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-page', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "display-1 mb-3"
  }, [_vm._v("Seach results")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "scrollable": false
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      attrs: {
        "href": '#' + tab.id
      }
    }, [_vm._v(" " + _vm._s(tab.text) + "\n            ")])
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("youtube")])], 2), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', {
    key: "meyouseek",
    attrs: {
      "id": "meyouseek",
      "transition": "",
      "reverse-transition": "",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('meyouseek', {
    on: {
      "next": function($event) {
        _vm.active = 'youtube'
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Work in progress")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "label": "Email",
      "id": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "prepend-icon": "person",
      "label": "Username",
      "id": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "prepend-icon": "lock",
      "label": "Password",
      "id": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "ajax": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_vm._v("\n                Register\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-grid-list', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tags,
      "item-text": "name",
      "item-value": "id",
      "label": "Select Tags",
      "small-chips": "",
      "max-height": "400",
      "content-class": "select-tags",
      "single-line": "",
      "append-icon": "local_offer",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (data.index < 1),
            expression: "data.index < 1"
          }],
          staticClass: "chip--select-multi"
        }, [_vm._v("\n                        " + _vm._s(data.item.name) + "\n                    ")]), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": "",
            "max-width": "200"
          }
        }, [(data.index === 1) ? _c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("(+" + _vm._s(data.parent.selectedItems.length - 1) + ")")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.parent.selectedItems.filter(function (v) { return v.name !== data.item.name; }).map(function (v) { return v.name; }).join(", ")))])])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-action', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "input-value": data.parent.selectedItems.includes(data.item)
          }
        })], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                        " + _vm._s(data.item.name) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-action', {
          staticClass: "hidden",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.form.tagIds = [data.item.id]
            }
          }
        }, [_c('v-btn', {
          staticClass: "min-width-0",
          attrs: {
            "small": ""
          }
        }, [_vm._v("ONLY")])], 1)]
      }
    }]),
    model: {
      value: (_vm.form.tagIds),
      callback: function($$v) {
        _vm.$set(_vm.form, "tagIds", $$v)
      },
      expression: "form.tagIds"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs6": "",
      "sm4": "",
      "lg2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.times,
      "max-height": "400",
      "offset-y": ""
    },
    model: {
      value: (_vm.form.time),
      callback: function($$v) {
        _vm.$set(_vm.form, "time", $$v)
      },
      expression: "form.time"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs6": "",
      "sm4": "",
      "lg2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sort By",
      "items": _vm.sorts,
      "max-height": "400",
      "offset-y": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "lg9": "",
      "xs12": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "page-fade",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('v-card', {
    staticClass: "pb-3"
  }, [_c('v-layout', {
    staticClass: "pa-3  hover-show-hidden",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "hidden-xs-only",
    attrs: {
      "width": "224",
      "height": "126",
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('v-btn', {
    staticClass: "no-transition",
    staticStyle: {
      "opacity": "0.9"
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.play(false)
      }
    }
  }, [_vm._v("\n                                    PLAY ALL\n                                ")])], 1)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "px-3"
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    staticClass: "shrink",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('h1', {
    staticClass: "display-1 name truncate"
  }, [_vm._v("Likes")])])], 1), _vm._v(" "), _c('v-flex', [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.play('shuffled')
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("shuffle")])], 1), _vm._v(" "), _c('span', [_vm._v("Play shuffled")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "id": "list-audios",
      "two-line": ""
    }
  }, [_c('v-layout', {
    staticClass: "fill-height justify-center",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "fill-height",
    attrs: {
      "md9": ""
    }
  }, [_c('v-subheader', {
    staticClass: "fill-height"
  }, [_vm._v(_vm._s(_vm.audios.length) + " Audios")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('transition-group', _vm._l((_vm.audios), function(audio, index) {
    return _c('div', {
      key: index
    }, [_c('playlist-audio', {
      attrs: {
        "audio": audio,
        "index": index,
        "editable": false
      }
    }), _vm._v(" "), (index + 1 < _vm.audios.length) ? _c('v-divider') : _vm._e()], 1)
  }))], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Work in progress")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('url|required'),
      expression: "'url|required'"
    }],
    attrs: {
      "value": _vm.value,
      "label": "Source URL",
      "name": "source",
      "id": "source",
      "hint": "Link to the full track",
      "persistent-hint": "",
      "rules": [_vm.customURL],
      "required": "",
      "autocomplete": "off",
      "error-messages": _vm.errors.collect('source')
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      },
      "paste": _vm.validate
    }
  })
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tile": "",
      "hover": ""
    }
  }, [_c('playlist-teaser-image', {
    attrs: {
      "playlist": _vm.playlist
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Playlist',
        params: {
          id: _vm.playlist.id
        }
      }
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h4', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.playlist.title))])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    staticClass: "pa-3 mb-2 grey lighten-3 black--text",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$store.state.user.user.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v(_vm._s(_vm.$store.state.user.user.email))])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: " "
  }, [_vm._v("Sign Out")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('page-title', [_vm._v("Add Track")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "dismissible": ""
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n            Before you proceed, please make sure that track was not added already\n        ")]), _vm._v(" "), _c('form', [_c('v-subheader', {
    staticClass: "grey--text"
  }, [_c('strong', [_vm._v("Primary Info")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('input-track-source', {
    on: {
      "linked": _vm.autoFill
    },
    model: {
      value: (_vm.form.previewSource),
      callback: function($$v) {
        _vm.$set(_vm.form, "previewSource", $$v)
      },
      expression: "form.previewSource"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "disabled": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('span', [_vm._v("YouTube URL "), _c('br'), _vm._v(" where we can listen to the track")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('p', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Provider Title:")]), _vm._v(" "), _c('u', {
    staticClass: " "
  }, [_vm._v(_vm._s(_vm.providerTitle || "-"))])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('input-track-artist', {
    model: {
      value: (_vm.form.artist),
      callback: function($$v) {
        _vm.$set(_vm.form, "artist", $$v)
      },
      expression: "form.artist"
    }
  }), _vm._v(" "), _c('input-track-title', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.swap
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("swap_vert")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('span', [_vm._v("Swap Artist and Title")])])], 1)], 1)], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "grey--text"
  }, [_c('strong', [_vm._v("Metadata (optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('input-audio-tags', {
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("Add Track")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "label": "Email",
      "id": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "prepend-icon": "lock",
      "label": "Password",
      "id": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    ref: "btnLogin",
    attrs: {
      "color": "secondary",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getToken($event)
      }
    }
  }, [_vm._v("\n            Login\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('div', [_vm._v("\n            Debug:\n            "), _c('br'), _vm._v(" "), _c('audio', {
    ref: "audio",
    attrs: {
      "controls": ""
    }
  }, [(_vm.player.audio) ? _c('source', {
    attrs: {
      "src": _vm.player.audio.previewSource,
      "type": "audio/mpeg"
    }
  }) : _vm._e(), _vm._v("\n                Your browser does not support the audio element.\n            ")]), _vm._v(" "), _c('br'), _vm._v("\n\n            Use these controls:\n            "), _c('br')]), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "time",
    staticClass: "semi-bold text-xs-center",
    attrs: {
      "id": "time-tooltip"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tooltipTime) + "\n                    ")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "grey lighten-2 ma-0 pa-0",
    attrs: {
      "buffer-value": _vm.bufferValue,
      "buffer": "",
      "id": "progress-bar",
      "height": "10"
    },
    on: {
      "click": _vm.onClick,
      "mousemove": function($event) {
        _vm.showTime($event)
      },
      "mouseout": function($event) {
        _vm.hideTime($event)
      }
    },
    model: {
      value: (_vm.buffer),
      callback: function($$v) {
        _vm.buffer = $$v
      },
      expression: "buffer"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center"
  }, [_c('v-flex', [_c('v-btn', {
    ref: "repeat",
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.toggleRepeat
    }
  }, [(_vm.player.repeat === 0) ? _c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("repeat")]) : (_vm.player.repeat === 1) ? _c('v-icon', [_vm._v("repeat_one")]) : _c('v-icon', [_vm._v("repeat")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.playlist.length,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playPrevious
    }
  }, [_c('v-icon', [_vm._v("skip_previous")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.player.state !== 1),
      expression: "player.state !== 1"
    }],
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.audio,
      "large": "",
      "icon": "",
      "dark": "",
      "color": !_vm.player.audio ? 'grey lighten-1' : 'secondary'
    },
    on: {
      "click": function($event) {
        _vm.player.state = 1
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.player.state === 1),
      expression: "player.state === 1"
    }],
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.audio,
      "large": "",
      "icon": "",
      "color": "secondary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.player.state = 2
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.canNext,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playNext
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.player.shuffle = !_vm.player.shuffle
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.player.shuffle ? '' : 'grey'
    }
  }, [_vm._v("shuffle")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Playlist:\n                "), (_vm.player.playlist) ? _c('v-list', [_c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    on: {
      "start": _vm.onDragStart,
      "end": _vm.onDragEnd
    },
    model: {
      value: (_vm.player.playlist),
      callback: function($$v) {
        _vm.$set(_vm.player, "playlist", $$v)
      },
      expression: "player.playlist"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.player.playlist), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.player.position = i
        }
      }
    }, [_c('v-list-tile-action', [_c('div', {
      staticClass: "handle hidden"
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("drag_indicator")])], 1)]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.position === i),
        expression: "player.position === i"
      }]
    }, [_c('v-icon', [_vm._v("play_arrow")])], 1)])]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                                    " + _vm._s(audio.id) + "\n                                ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.position !== i),
        expression: "player.position !== i"
      }],
      staticClass: "hidden no-transition",
      attrs: {
        "icon": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.remove(i)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("delete")])], 1)], 1)], 1)
  }))], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Audios not in playlist:\n                "), _c('v-list', _vm._l((_vm.audiosNotInPlaylist), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.playAudio(audio)
        }
      }
    }, [_c('v-list-tile-content', [_vm._v("\n                            " + _vm._s(audio.id) + "\n                        ")])], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Playlist 1:\n                "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.playPlaylistRandomized(_vm.playlist1)
      }
    }
  }, [_vm._v("Play playlist 1 Randomized")]), _vm._v(" "), _c('v-list', {
    key: 1
  }, [_c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    model: {
      value: (_vm.playlist1.audios),
      callback: function($$v) {
        _vm.$set(_vm.playlist1, "audios", $$v)
      },
      expression: "playlist1.audios"
    }
  }, _vm._l((_vm.playlist1.audios), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.playAudio(audio, _vm.playlist1, i)
        }
      }
    }, [_c('v-list-tile-action', [_c('div', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.audio && _vm.player.audio.id === audio.id),
        expression: "player.audio && player.audio.id === audio.id"
      }]
    }, [_c('v-icon', [_vm._v("play_arrow")])], 1)])]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                                " + _vm._s(audio.id) + "\n                            ")])], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Playlist 2:\n                "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.playPlaylistRandomized(_vm.playlist2)
      }
    }
  }, [_vm._v("Play playlist 2 Randomized")]), _vm._v(" "), _c('v-list', {
    key: 2
  }, [_c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    model: {
      value: (_vm.playlist2.audios),
      callback: function($$v) {
        _vm.$set(_vm.playlist2, "audios", $$v)
      },
      expression: "playlist2.audios"
    }
  }, [_c('transition-group', _vm._l((_vm.playlist2.audios), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.playAudio(audio, _vm.playlist2, i)
        }
      }
    }, [_c('v-list-tile-action', [_c('div', {
      staticClass: "handle hidden"
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("drag_indicator")])], 1)]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.audio && _vm.player.audio.id === audio.id),
        expression: "player.audio && player.audio.id === audio.id"
      }]
    }, [_c('v-icon', [_vm._v("play_arrow")])], 1)])]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                                    " + _vm._s(audio.id) + "\n                                ")])], 1)
  }))], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Edit Track Name")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "New Name",
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": _vm.value,
      "label": "Artist",
      "name": "artist",
      "id": "artist",
      "persistent-hint": "",
      "hint": "The primary artist (author)",
      "required": "",
      "error-messages": _vm.errors.collect('artist')
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', _vm._b({
    attrs: {
      "fluid": _vm.fluid
    }
  }, 'v-container', ( _obj = {}, _obj[("grid-list-" + (_vm.$vuetify.breakpoint.name))] = true, _obj ), false), [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._t("default")], 2)], 1)
  var _obj;
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    Page Not Found\n")])
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    staticClass: "hover-show-hidden"
  }, [(!_vm.playlist || _vm.playlist.user_id === _vm.$auth.user.id) ? _c('v-list-tile-action', {
    staticClass: "handle"
  }, [(_vm.editable && _vm.sort === 'position') ? _c('div', [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("drag_indicator")]), _vm._v("\n            " + _vm._s( /** index + 1 **/ ) + "\n        ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "pa-1",
    staticStyle: {
      "min-width": "87px !important",
      "max-width": "87px !important"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": "",
      "width": "87"
    }
  }, [_c('audio-image', {
    attrs: {
      "audio": _vm.audio,
      "height": "65px"
    }
  })], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "list__tile__content",
    class: {
      'width-xs': _vm.$vuetify.breakpoint.xsOnly
    },
    staticStyle: {
      "text-decoration": "none",
      "color": "inherit"
    },
    attrs: {
      "to": {
        name: 'Track',
        params: {
          id: _vm.audio.id
        }
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.audio.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.audio.artist))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', [(_vm.editable) ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    staticClass: "no-hover-opacity hidden no-transition",
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": "",
      "ripple": false
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": _vm.remove
    }
  }, [_c('v-list-tile-content', [_vm._v("\n                        Remove from playlist\n                    ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-page', [_c('v-tabs', {
    attrs: {
      "color": "transparent"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      attrs: {
        "href": ("#" + (tab.id)),
        "disabled": tab.id === 'tab-channels'
      }
    }, [_vm._v(_vm._s(tab.text) + "\n        ")])
  })), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "id": "tab-tracks",
      "transition": false,
      "reverse-transition": false
    }
  }, [_c('tracks-filters', {
    on: {
      "input": _vm.updateFilters
    }
  }), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "length": _vm.last_page,
      "total-visible": _vm.$vuetify.breakpoint.xsOnly ? 5 : 7
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }), _vm._v(" "), _c('app-grid-list', _vm._l((_vm.tracks), function(track) {
    return _c('v-flex', {
      key: track.id,
      attrs: {
        "xs12": "",
        "sm4": "",
        "md3": "",
        "lg2": ""
      }
    }, [_c('audio-teaser', {
      attrs: {
        "audio": track
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-channels",
      "transition": false,
      "reverse-transition": false
    }
  }, [_vm._v("\n            []...\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "label": "Email",
      "id": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "prepend-icon": "person",
      "label": "Username",
      "id": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "prepend-icon": "lock",
      "label": "Password",
      "id": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "ajax": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_vm._v("\n                    Register\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('transition', {
    attrs: {
      "name": "page-fade",
      "mode": "out-in"
    }
  }, [(_vm.playlist) ? _c('v-flex', {
    attrs: {
      "lg9": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pb-3"
  }, [_c('v-layout', {
    staticClass: "pa-3 hover-show-hidden",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "hidden-xs-only",
    attrs: {
      "width": "224",
      "height": "126",
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('v-btn', {
    staticClass: "no-transition",
    staticStyle: {
      "opacity": "0.9"
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.play(false)
      }
    }
  }, [_vm._v("\n                                    PLAY ALL\n                                ")])], 1)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "px-3"
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    staticClass: "shrink",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('h1', {
    staticClass: "display-1 name truncate"
  }, [_vm._v(_vm._s(_vm.playlist.title))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    staticClass: "hidden no-transition",
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    key: _vm.playlist.id
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.deletePlaylist
    }
  }, [_vm._v("\n                                                Delete Playlist\n                                            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.play('shuffled')
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("shuffle")])], 1), _vm._v(" "), _c('span', [_vm._v("Play shuffled")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "grey--text justify-end"
  }, [_c('span', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "grey"
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.playlist.user.name))]), _vm._v(" "), _c('span', {
    staticClass: "created-at"
  }, [_vm._v(_vm._s(_vm.$timeago().format(_vm.playlist.created_at)))])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    ref: "list-audios",
    staticClass: "py-0 use-hover",
    attrs: {
      "id": "list-audios",
      "two-line": ""
    }
  }, [_c('v-layout', {
    staticClass: "fill-height justify-center",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "fill-height",
    attrs: {
      "md9": ""
    }
  }, [_c('v-subheader', {
    staticClass: "fill-height"
  }, [_vm._v(_vm._s(_vm.playlist.audios.length) + " Audios")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "max-width": "250px"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.sortItems,
      "solo": "",
      "offset-y": ""
    },
    model: {
      value: (_vm.sort),
      callback: function($$v) {
        _vm.sort = $$v
      },
      expression: "sort"
    }
  })], 1)], 1), _vm._v(" "), _c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    on: {
      "update": _vm.onUpdate,
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.playlist.audios),
      callback: function($$v) {
        _vm.$set(_vm.playlist, "audios", $$v)
      },
      expression: "playlist.audios"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-basic"
    }
  }, _vm._l((_vm.playlist.audios), function(audio, index) {
    return _c('div', {
      key: audio.id
    }, [_c('playlist-audio', {
      attrs: {
        "audio": audio,
        "index": index,
        "playlist": _vm.playlist,
        "sort": _vm.sort
      },
      on: {
        "removed": _vm.onRemoved
      }
    }), _vm._v(" "), (index + 1 < _vm.playlist.audios.length) ? _c('v-divider') : _vm._e()], 1)
  }))], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('v-layout', [_c('v-flex', [_c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "solo": "",
      "light": "",
      "placeholder": "Search",
      "autofocus": ""
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      }
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "grey--text ml-0 mr-0 mt-2",
    attrs: {
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.submit($event)
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "btn--floating btn--flat"
  }, [_vm._v("TEST")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.customHTML)
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-select', {
    ref: "mySelect",
    attrs: {
      "items": _vm.items,
      "autocomplete": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-page', [_c('transition', {
    attrs: {
      "name": "page-fade",
      "mode": "out-in"
    }
  }, [(_vm.track) ? _c('v-card', {
    attrs: {
      "height": "700"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg3": ""
    }
  }, [_c('v-card', [_c('audio-image', {
    attrs: {
      "audio": _vm.track,
      "height": "200px"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2 pt-2",
    attrs: {
      "xs12": "",
      "sm8": "",
      "lg9": ""
    }
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    staticClass: "shrink",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('h1', {
    staticClass: "display-1 name truncate"
  }, [_vm._v(_vm._s(_vm.track.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "shrink": ""
    }
  }, [_c('h2', {
    staticClass: "title grey--text"
  }, [_vm._v(_vm._s(_vm.track.artist))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_vm._l((_vm.track.tags), function(tag, index) {
    return _c('v-chip', {
      key: index,
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(tag.name))])
  }), _vm._v(" "), (_vm.$auth.user.id) ? _c('v-btn', {
    staticClass: "ma-0 no-hover-opacity",
    attrs: {
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogAddTag = !_vm.dialogAddTag
      }
    }
  }, [_c('span', [_vm._v("Edit tags")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('dialog-add-tag', {
    attrs: {
      "audio": _vm.track
    },
    model: {
      value: (_vm.dialogAddTag),
      callback: function($$v) {
        _vm.dialogAddTag = $$v
      },
      expression: "dialogAddTag"
    }
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "grey--text mt-3",
    attrs: {
      "shrink": ""
    }
  }, [_c('span', [_vm._v("Added by")]), _vm._v(" "), _c('a', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm.track.user.name))])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "xs12": ""
    }
  }, [_c('like', {
    key: _vm.track.id,
    attrs: {
      "audio": _vm.track
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-atp",
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.atpMenu = !_vm.atpMenu
      }
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1), _vm._v(" "), _c('menu-add-to-playlist', {
    attrs: {
      "audio": _vm.track,
      "activator": ".btn-atp",
      "right": ""
    },
    model: {
      value: (_vm.atpMenu),
      callback: function($$v) {
        _vm.atpMenu = $$v
      },
      expression: "atpMenu"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#lyrics",
      "disabled": ""
    }
  }, [_vm._v("Lyrics")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#comments",
      "disabled": ""
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#resources",
      "disabled": ""
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "id": "lyrics"
    }
  }, [_c('v-card', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Work in progress")])])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Work in progress")]), _vm._v(" "), _c('app-grid-list', _vm._l((_vm.playlists), function(playlist) {
    return _c('v-flex', {
      key: playlist.id,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg2": ""
      }
    }, [_c('playlist-teaser', {
      attrs: {
        "playlist": playlist
      }
    })], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value,
      "label": "Lyrics Source",
      "name": "lyrics",
      "id": "lyrics",
      "persistent-hint": "",
      "hint": "Link where we can read lyrics",
      "error-messages": _vm.errors.collect('lyrics')
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-media', {
    staticClass: "img-scale",
    attrs: {
      "height": _vm.height,
      "src": _vm.audio.imgSource,
      "alt": ""
    }
  }, [(_vm.audio.imgSource !== _vm.defaultImageSrc) ? _c('v-layout', {
    staticClass: "audio-overlay",
    attrs: {
      "align-center": ""
    }
  }, [(_vm.actions.play) ? _c('v-flex', {
    staticClass: "text-xs-center"
  }, [(_vm.audio.id === _vm.currentAudioId && _vm.player.state === 1) ? _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('pause')
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1) : _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('playAudio', _vm.audio)
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.actions.watchLater) ? _c('v-btn', {
    staticClass: "watch-later",
    attrs: {
      "icon": "",
      "color": "grey darken-3"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("watch_later")])], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "label": "Email",
      "id": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "prepend-icon": "lock",
      "label": "Password",
      "id": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    ref: "btnLogin",
    attrs: {
      "color": "secondary",
      "loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getToken($event)
      }
    }
  }, [_vm._v("\n                Login\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-0 hover-show-hidden",
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('div', {
    staticClass: "cover-container mb-1"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "",
      "src": _vm.audio.imgSource
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "genre px-1 primary white--text semi-bold hidden"
  }, [_vm._v(_vm._s(_vm.audio.genre))]), _vm._v(" "), (!_vm.player.playlist.slice(_vm.player.position + 1).find(function (v) { return v.id === _vm.audio.id; })) ? _c('v-btn', {
    key: "watch-later",
    staticClass: "watch-later hidden ma-1",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "icon": "",
      "color": "grey darken-3"
    },
    on: {
      "click": _vm.addToNextUp
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("queue_music")])], 1) : _c('v-btn', {
    key: "in-watch-later",
    staticClass: "in-watch-later hidden ma-1",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "icon": "",
      "color": "grey darken-3"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), (_vm.actions.play) ? _c('div', {
    staticClass: "play-pause hidden"
  }, [(_vm.$store.getters.audio && (_vm.audio.id === _vm.$store.getters.audio.id) && (_vm.player.state === 1)) ? _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('pause')
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1) : _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('playAudio', _vm.audio)
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    class: {
      'white--text': _vm.$vuetify.dark, 'black--text': !_vm.$vuetify.dark,
    },
    staticStyle: {
      "text-decoration": "none",
      "position": "relative"
    },
    attrs: {
      "to": {
        name: 'Track',
        params: {
          id: _vm.audio.id
        }
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    staticClass: "ma-0",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0 truncate-2 semi-bold",
    attrs: {
      "shrink": ""
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.audio.name
    }
  }, [_vm._v(_vm._s(_vm.audio.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 hidden more-vert",
    attrs: {
      "shrink": ""
    }
  }, [_c('v-btn', {
    staticClass: "right ma-0 pa-0 no-hover-opacity",
    attrs: {
      "id": ("btn-more-" + _vm._uid),
      "small": "",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.menuMore = !_vm.menuMore
      }
    }
  }, [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "activator": ("#btn-more-" + _vm._uid)
    },
    model: {
      value: (_vm.menuMore),
      callback: function($$v) {
        _vm.menuMore = $$v
      },
      expression: "menuMore"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-title', {
    on: {
      "click": _vm.atp
    }
  }, [_vm._v("Add to")])], 1)], 1)], 1), _vm._v(" "), _c('menu-add-to-playlist', {
    attrs: {
      "audio": _vm.audio,
      "activator": ("#btn-more-" + _vm._uid),
      "left": ""
    },
    model: {
      value: (_vm.menuAtp),
      callback: function($$v) {
        _vm.menuAtp = $$v
      },
      expression: "menuAtp"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 body-1 truncate mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "grey--text",
    attrs: {
      "title": _vm.audio.artist
    }
  }, [_vm._v(_vm._s(_vm.audio.artist))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 grey--text caption",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "likes"
  }, [_vm._v("\n                    " + _vm._s(_vm.$nFormat(_vm.audio.likes_count || 0)) + "\n                    "), _c('v-icon', {
    attrs: {
      "small": "",
      "color": "grey lighten-1"
    }
  }, [_vm._v("favorite")])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.audio.created_at
    }
  }, [_vm._v(_vm._s(_vm.$timeago().format(_vm.audio.created_at)))])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('div', {
    staticClass: "input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.q),
      expression: "q",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "search",
      "type": "search",
      "required": "",
      "autocomplete": "off",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.q)
    },
    on: {
      "focus": _vm.show,
      "blur": [_vm.hide, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.q = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-icon",
    attrs: {
      "for": "search"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-suggested"
    }
  }, _vm._l((_vm.suggestions), function(s, i) {
    return _c('suggested', {
      key: i,
      on: {
        "mousedown": function($event) {
          _vm.select(_vm.q)
        }
      }
    })
  }))])])
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-grid-list', _vm._l((_vm.audios), function(audio) {
    return _c('v-flex', {
      key: audio.id,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg2": ""
      }
    }, [_c('audio-teaser', {
      attrs: {
        "audio": audio
      }
    })], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "grey lighten-4",
    class: {
      'height': _vm.$vuetify.breakpoint.lgAndUp
    },
    attrs: {
      "right": "",
      "app": "",
      "fixed": "",
      "clipped": "",
      "floating": "",
      "disable-route-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3",
    attrs: {
      "d-flex": "",
      "align-center": ""
    }
  }, [_vm._v("\n            {Player Type}\n        ")]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "color": "grey",
      "id": "btn-toggle"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('v-icon', [_vm._v("keyboard_arrow_up")]) : _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.show
    },
    attrs: {
      "id": "external-player"
    }
  }, [_c('div', {
    attrs: {
      "id": "youtube-player"
    }
  })]), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('h4', [_vm._v("List Title")])]), _vm._v(" "), _vm._l((_vm.tracks), function(track, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-action', [_vm._v("\n                " + _vm._s(i + 1) + "\n            ")]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(track) + "\n                ")])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('v-card', [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#tab-login"
    }
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-register"
    }
  }, [_vm._v("Register")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "fill-height",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 1,
    attrs: {
      "id": "tab-login"
    }
  }, [_c('form-login', {
    staticClass: "pa-3"
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    attrs: {
      "id": "tab-register"
    }
  }, [_c('form-register', {
    staticClass: "pa-3"
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [(_vm.track) ? _c('v-flex', [_c('h1', {
    staticClass: "display-1"
  }, [_vm._v("Edit Track")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.track.name) + "\n            "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogName = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.track.artist) + "\n            "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogArtist = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('dialog-name', {
    attrs: {
      "track": _vm.track
    },
    model: {
      value: (_vm.dialogName),
      callback: function($$v) {
        _vm.dialogName = $$v
      },
      expression: "dialogName"
    }
  }), _vm._v(" "), _c('dialog-artist', {
    attrs: {
      "track": _vm.track
    },
    model: {
      value: (_vm.dialogArtist),
      callback: function($$v) {
        _vm.dialogArtist = $$v
      },
      expression: "dialogArtist"
    }
  }), _vm._v(" "), _c('dialog-source', {
    attrs: {
      "track": _vm.track
    },
    model: {
      value: (_vm.dialogSource),
      callback: function($$v) {
        _vm.dialogSource = $$v
      },
      expression: "dialogSource"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("apps")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "href": "http://localhost:8042/"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "black--text"
  }, [_vm._v("Lyrex")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    attrs: {
      "value": _vm.value,
      "activator": _vm.activator,
      "offset-y": "",
      "content-class": "playlists"
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, 'v-menu', _vm.$attrs, false), [_c('v-list', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-list-tile', [_vm._v("Add to")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, _vm._l((_vm.playlists), function(playlist) {
    return _c('playlist', {
      key: playlist.id,
      staticClass: "mb-2 mx-3",
      attrs: {
        "playlist": playlist,
        "audio-id": _vm.audio.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.playlists.length) ? _c('v-divider', {
    staticClass: "mb-2"
  }) : _vm._e(), _vm._v(" "), (!_vm.creatingPlaylist) ? _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.creatingPlaylist = true
      }
    }
  }, [_c('v-layout', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "d-flex": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n                Create new playlist\n            ")], 1)], 1) : [_c('v-list-tile', [_c('v-text-field', {
    attrs: {
      "label": "Title",
      "id": "title",
      "name": "title",
      "required": "",
      "rules": [function () { return !!_vm.form.title || 'This field is required'; }],
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('v-list-tile', [_c('v-select', {
    attrs: {
      "label": "Visibility",
      "items": ['private', 'secret', 'public']
    },
    model: {
      value: (_vm.form.visibility),
      callback: function($$v) {
        _vm.$set(_vm.form, "visibility", $$v)
      },
      expression: "form.visibility"
    }
  })], 1), _vm._v(" "), _c('v-list-tile', [_c('v-spacer'), _vm._v(" "), _c('app-btn', {
    ref: "btnSubmit",
    staticClass: "right",
    attrs: {
      "flat": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("\n                    Create\n                ")])], 1)]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "lg9": "",
      "xs12": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "page-fade",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('v-card', {
    staticClass: "pb-3"
  }, [_c('v-layout', {
    staticClass: "pa-3  hover-show-hidden",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "hidden-xs-only",
    attrs: {
      "width": "224",
      "height": "126",
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('v-btn', {
    staticClass: "no-transition",
    staticStyle: {
      "opacity": "0.9"
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.play(false)
      }
    }
  }, [_vm._v("\n                                    PLAY ALL\n                                ")])], 1)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "px-3"
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    staticClass: "shrink",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('h1', {
    staticClass: "display-1 name truncate"
  }, [_vm._v("History")])])], 1), _vm._v(" "), _c('v-flex', [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.play('shuffled')
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("shuffle")])], 1), _vm._v(" "), _c('span', [_vm._v("Play shuffled")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "id": "list-audios",
      "two-line": ""
    }
  }, [_c('v-layout', {
    staticClass: "fill-height justify-center",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "fill-height",
    attrs: {
      "md9": ""
    }
  }, [_c('v-subheader', {
    staticClass: "fill-height"
  }, [_vm._v(_vm._s(_vm.audios.length) + " Audios")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('transition-group', _vm._l((_vm.audios), function(audio, index) {
    return _c('div', {
      key: index
    }, [_c('playlist-audio', {
      attrs: {
        "audio": audio,
        "index": index,
        "editable": false
      }
    }), _vm._v(" "), (index + 1 < _vm.audios.length) ? _c('v-divider') : _vm._e()], 1)
  }))], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_vm._v("\n        subs\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "600px",
      "lazy": ""
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("View and edit tags for this track")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('v-subheader', [_vm._v("Tagged by others")]), _vm._v(" "), (_vm.audioTags.length) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.audioTags), function(tag, index) {
    return [_c('v-list-tile', {
      key: tag.id + 100000
    }, [_c('v-list-tile-content', [_vm._v("\n                                        " + _vm._s(tag.name) + "\n                                    ")]), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                                        " + _vm._s(tag.user_count) + "\n                                    ")])], 1), _vm._v(" "), _c('v-divider', {
      key: index
    })]
  })], 2) : _c('div', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Nothing here yet")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_vm._v("\n\n                        Tags should be in "), _c('strong', [_vm._v("English")]), _vm._v(".\n                        "), _c('br'), _vm._v("\n                        Use terms that you think other users would find useful to browse by.\n\n                        "), _c('input-audio-tags', {
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Apply a tag that you've already applied to other tracks:")]), _vm._v(" "), (_vm.userDistinctTags.length) ? _vm._l((_vm.userDistinctTags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      staticClass: "hover-show-hidden",
      attrs: {
        "small": ""
      }
    }, [_vm._v("\n                                    " + _vm._s(tag.name) + "\n                                    "), _c('v-icon', {
      staticClass: "hidden no-transition",
      attrs: {
        "right": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addTag(tag)
        }
      }
    }, [_vm._v("add_circle\n                                    ")])], 1)
  }) : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters.audio) ? _c('v-layout', {
    staticClass: "align-center"
  }, [_c('v-flex', {
    staticClass: "mr-3",
    attrs: {
      "shrink": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.getters.audio.imgSource,
      "alt": "",
      "width": "72",
      "height": "72"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-0"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Track',
        params: {
          id: _vm.audio.id
        }
      }
    }
  }, [_c('v-flex', {
    staticClass: "pa-0 truncate semi-bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.$store.getters.audio.name))])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 truncate"
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$store.getters.audio.artist))])])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "shrink": ""
    }
  }, [_c('button-like-audio', {
    key: _vm.audio.id,
    attrs: {
      "audio": _vm.audio
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("favorite")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.isAuthenticating) ? _c('v-app', {
    attrs: {
      "dark": _vm.dark
    }
  }, [_c('the-left-sidebar', {
    ref: "leftSidebar",
    attrs: {
      "dark": _vm.dark
    },
    on: {
      "update:dark": function($event) {
        _vm.dark = $event
      }
    }
  }), _vm._v(" "), _c('the-header', {
    on: {
      "toggle-drawer": function($event) {
        _vm.$refs.leftSidebar.drawer = !_vm.$refs.leftSidebar.drawer
      }
    }
  }), _vm._v(" "), _c('v-content', [_c('v-container', {
    class: {
      'pa-1': _vm.fluid
    },
    attrs: {
      "fluid": _vm.fluid
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('the-player', {
    on: {
      "toggle-drawer": function($event) {
        _vm.$refs.rightSidebar.drawer = !_vm.$refs.rightSidebar.drawer
      }
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "left": _vm.$vuetify.breakpoint.lgAndUp,
      "bottom": _vm.$vuetify.breakpoint.lgAndUp,
      "top": _vm.$vuetify.breakpoint.mdAndDown,
      "right": _vm.$vuetify.breakpoint.mdAndDown
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.snackbar.text) + "\n            ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": _vm.value,
      "label": "Title",
      "name": "title",
      "id": "title",
      "autocomplete": "off",
      "required": "",
      "error-messages": _vm.errors.collect('title')
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.toggleLiked
    }
  }, [(_vm.liked) ? _c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("favorite")]) : _c('v-icon', [_vm._v("favorite_border")])], 1)
},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'desktop': _vm.$vuetify.breakpoint.lgAndUp
    },
    attrs: {
      "id": "youtube-player"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-lg-and-down",
    attrs: {
      "lg3": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "pb-0",
    class: {
      'height': _vm.$vuetify.breakpoint.lgAndUp, 'grey lighten-4': !_vm.$vuetify.dark, 'grey darken-4': _vm.$vuetify.dark
    },
    attrs: {
      "fixed": "",
      "app": "",
      "clipped": "",
      "floating": "",
      "disable-route-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    staticClass: "mb-2",
    attrs: {
      "to": {
        name: 'Browse'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4 "
  }, [_vm._v("album")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Browse")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.user.isAuthenticated) ? [_c('v-subheader', {
    staticClass: "ml-3 body-2 grey--text"
  }, [_vm._v("\n                LIBRARY\n                ")]), _vm._v(" "), _c('v-list-tile', {
    key: "history",
    staticClass: "playlist",
    attrs: {
      "to": "/history"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4"
  }, [_vm._v("history")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("History")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    key: "likes",
    staticClass: "playlist",
    attrs: {
      "to": "/likes"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4"
  }, [_vm._v("favorite")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Likes")])], 1)], 1), _vm._v(" "), _vm._l((_vm.user.user.playlists), function(playlist, i) {
    return (i < 3 || _vm.showMore) ? _c('v-list-tile', {
      key: playlist.id,
      staticClass: "playlist",
      attrs: {
        "to": {
          name: 'Playlist',
          params: {
            id: playlist.id
          }
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "ml-3 mr-4",
      domProps: {
        "textContent": _vm._s(playlist.title === 'Liked' ? 'favorite' : playlist.title === 'History' ? 'history' : 'playlist_play')
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(playlist.title))])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.user.user.playlists.length > 3) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4",
    domProps: {
      "textContent": _vm._s(_vm.showMore ? 'keyboard_arrow_up' : 'keyboard_arrow_down')
    }
  })], 1), _vm._v(" "), (_vm.showMore) ? [_vm._v("Show Less")] : [_vm._v("Show More")]], 2) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "ml-3 body-2 grey--text"
  }, [_vm._v("\n                    CONTRIBUTE\n                ")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'TracksCreate'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4 "
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Add a track")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.toggleTheme
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    staticClass: "pt-2",
    attrs: {
      "label": "",
      "color": "grey darken-3",
      "hide-details": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.dark),
      callback: function($$v) {
        _vm.dark = $$v
      },
      expression: "dark"
    }
  })], 1), _vm._v("\n                Theme: " + _vm._s(this.dark ? 'Dark' : 'Light') + "\n\n            ")], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list', {
    staticClass: "grey--text footer"
  }, [_c('v-list-tile')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    sc\n")])
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.playlist) ? _c('v-layout', [_c('v-flex', [_c('h1', {
    staticClass: "display-1"
  }, [_vm._v(_vm._s(_vm.playlist.title))]), _vm._v(" "), _vm._l((_vm.playlist.tracks), function(track) {
    return _c('div', {
      key: track.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Track',
          params: {
            id: track.id
          }
        }
      }
    }, [(track.edits[0]) ? _c('span', [_vm._v(_vm._s(track.edits[0].name))]) : _c('span', [_vm._v(_vm._s(track.name))]), _vm._v(" -\n                "), (track.edits[0]) ? _c('span', [_vm._v(_vm._s(track.edits[0].artist))]) : _c('span', [_vm._v(_vm._s(track.artist))])]), _vm._v(" "), _c('div', {
      staticClass: "divider"
    })], 1)
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', _vm._b({
    on: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, 'v-btn', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add Track Source")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "New Source",
      "required": ""
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "id": "attach",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = !_vm.menu
      }
    }
  }, [_c('v-icon', [_vm._v("playlist_play")])], 1), _vm._v(" "), _c('v-menu', {
    ref: "menu",
    attrs: {
      "attach": "#attach",
      "absolute": "",
      "top": "",
      "left": "",
      "close-on-content-click": false,
      "close-on-click": false,
      "max-height": "600",
      "max-width": _vm.$vuetify.breakpoint.smAndUp ? 480 : 300,
      "min-width": _vm.$vuetify.breakpoint.smAndUp ? 480 : 290
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-card', {
    staticClass: "fill-height"
  }, [(_vm.player.playlist) ? _c('v-list', {
    attrs: {
      "id": "next-up",
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "title"
  }, [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_vm._v("Next Up")]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "d-flex mr-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "depressed": ""
    },
    on: {
      "click": _vm.clearPlaylist
    }
  }, [_vm._v("\n                            Clear\n                        ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1)], 1)])], 1), _vm._v(" "), _c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    on: {
      "start": _vm.onDragStart,
      "end": _vm.onDragEnd
    },
    model: {
      value: (_vm.playlist),
      callback: function($$v) {
        _vm.playlist = $$v
      },
      expression: "playlist"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.player.playlist), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      class: {
        'no-hover-opacity': i < _vm.player.position
      }
    }, [_c('v-list-tile-action', {
      staticClass: "px-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.player.position === i) ? _c('v-progress-circular', {
      attrs: {
        "rotate": 270,
        "size": 22,
        "width": 3,
        "value": _vm.player.duration && (_vm.player.time / _vm.player.duration) * 100,
        "color": "primary"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("play_arrow")])], 1) : _c('div', {
      staticClass: "handle hidden"
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("drag_indicator")])], 1)], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('v-list-tile-action', {
      staticClass: "mr-1",
      on: {
        "click": function($event) {
          _vm.$store.dispatch('setPosition', i)
        }
      }
    }, [_c('div', {
      staticClass: "cover-container"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": audio.imgSource,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "hidden play-pause"
    }, [(_vm.player.position === i && _vm.player.state === 1) ? _c('v-btn', {
      staticClass: "no-transition",
      attrs: {
        "small": "",
        "icon": "",
        "dark": "",
        "ripple": false,
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.$store.dispatch('setState', 2)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("pause")])], 1) : _c('v-btn', {
      staticClass: "no-transition",
      attrs: {
        "small": "",
        "icon": "",
        "dark": "",
        "ripple": false,
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.$store.dispatch('setPosition', i) && _vm.$store.dispatch('setState', 1)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("play_arrow")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "v-list__tile__content",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "to": {
          name: 'Track',
          params: {
            id: audio.id
          }
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "semi-bold"
    }, [_vm._v("\n                                        " + _vm._s(audio.name) + "\n                                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                                        " + _vm._s(audio.artist) + "\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.position !== i),
        expression: "player.position !== i"
      }],
      staticClass: "hidden no-transition",
      attrs: {
        "icon": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.remove(i)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("delete")])], 1)], 1)], 1)
  }))], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": "",
      "dense": "",
      "fixed": "",
      "clipped-left": "",
      "app": ""
    }
  }, [_c('logo', {
    on: {
      "toggle-drawer": function($event) {
        _vm.$emit('toggle-drawer')
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-md-and-down"
  }, [_c('search-lg')], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-md-and-down f",
    attrs: {
      "shrink": ""
    }
  }, [(_vm.$auth.isAuthenticated()) ? _c('menu-profile') : _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.demoGetToken
    }
  }, [_vm._v("\n            Demo login\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    staticClass: "ml-2 mr-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tags,
      "item-text": "name",
      "item-value": "id",
      "label": "Select Tags",
      "max-height": "400",
      "autocomplete": "",
      "append-icon": "local_offer",
      "multiple": ""
    },
    model: {
      value: (_vm.filters.tags),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tags", $$v)
      },
      expression: "filters.tags"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-2 mr-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.times,
      "max-height": "400"
    },
    model: {
      value: (_vm.filters.time),
      callback: function($$v) {
        _vm.$set(_vm.filters, "time", $$v)
      },
      expression: "filters.time"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-2 mr-2"
  }, [_c('v-select', {
    attrs: {
      "label": "Sort By",
      "items": _vm.sorts,
      "max-height": "400"
    },
    model: {
      value: (_vm.filters.sort),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sort", $$v)
      },
      expression: "filters.sort"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-checkbox', {
    attrs: {
      "input-value": _vm.isInPlaylist,
      "label": _vm.playlist.title,
      "color": "primary",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  })
},staticRenderFns: []}

/***/ })
],[275]);


// WEBPACK FOOTER //
// static/js/app.3dd4b05dc9b4f858a021.js